import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Table,
  Input,
  Upload,
  Typography,
  Space,
  notification,
  Spin,
  Card,
  Row,
  Select,
  message,
  Modal,
  Form,
  Checkbox,
  Tooltip,
} from "antd";
import { useDebounce } from "use-debounce";

import { useGetPatientInsuranceEligibility } from "./useGetPatientInsuranceEligibility";
import PredeterminationModal from "./Predetermination/PredeterminationModal";
import InsuranceMasterModal from "./InsuranceMasterModal";
import NewEducationalContentModal from "./NewEducationalContentModal";
import PatientPolicyInfoFormModal from "./PatientPolicyInfoFormModal";
import Eligibility2FAFormModal from "./Eligibility2FAFormModal";
import SelectPolicyItemModal from "./SelectPolicyItemModal";
import EligibilityDataModal from "./EligibilityDataModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import AddFromPMSModal from "./AddFromPMSModal";
import PMSDataModal from "./PMSDataModal";
import ShareModal from "./ShareModal";
import ModalStep3 from "./ModalStep3";
import Priority from "./Priority";

// icons
import arrowRight from "../../../assets/icons/arrow-circle-right.svg";
import arrowLeft from "../../../assets/icons/arrow-circle-left.svg";
import agnetEditIcon from "../../../assets/icons/personal-card.svg";
import addCircle from "../../../assets/icons/add-circle-white.svg";
import downloadIcon from "../../../assets/icons/download-icon.png";
import tick from "../../../assets/icons/tick-circle-gray.svg";
import folder from "../../../assets/icons/folder-open.svg";
import excelIcon from "../../../assets/icons/excel.svg";
import powerIcon from "../../../assets/icons/power.svg";
import add from "../../../assets/icons/add-button.svg";
import delete1 from "../../../assets/icons/trash.png";
import wordIcon from "../../../assets/icons/word.svg";
import edit2 from "../../../assets/icons/edit-2.svg";
import mkvIcon from "../../../assets/icons/mkv.svg";
import mp4Icon from "../../../assets/icons/mp4.svg";
import pdfIcon from "../../../assets/icons/pdf.svg";
import check from "../../../assets/icons/check.png";
import edit1 from "../../../assets/icons/edit.png";
import book from "../../../assets/icons/book.svg";
import eye from "../../../assets/icons/eye.png";

import { controller as rootController } from "../../../controller";
import { controller } from "../controller";
import "../style.css";

// Defining the width of main columns
const EXTRA_COLUMNS_WIDTH = 60; // The width of each column
const { Title } = Typography;

const TreatmentCardStep2 = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [item, setItems] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [note, setNote] = useState("");
  const [imageFile, setImageFile] = useState([]);
  const [videoFile, setVideoFile] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState([]);
  const [edit, setEdit] = useState({});
  const [isModalVisible1, setIsModalVisible1] = useState(false);
  const [updatingPriority, setUpdatingPriority] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [data, setData] = useState([]);
  const [save, setSave] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [isModalVisible3, setIsModalVisible3] = useState(false);
  const [isModalVisible5, setIsModalVisible5] = useState(false);
  const [editState, setEditState] = useState({});
  const [expandedRowInputValues, setExpandedRowInputValues] = useState({});
  const [id, setId] = useState(null);
  const [treatmentId, setTreatmentId] = useState(null);
  const [eduid, setEduId] = useState(null);
  const [edu, setEdu] = useState([]);
  const [eduvalue, setEduValue] = useState([]);
  const [text, setText] = useState("");
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [desc2, setDesc2] = useState("");
  const [procedures, setProcedures] = useState([]);
  const [disableadd, setDisableAdd] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [selectedprocedure, setSelectedProcedure] = useState("");
  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [current, setCurrent] = useState(1);
  const [itemlist, setItemList] = useState([]);
  const [edulist, setEduList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [modaledit2, setModalEdit2] = useState(false);
  const [editingProcedureIndex, setEditingProcedureIndex] = useState(null);
  const [editedProcedures, setEditedProcedures] = useState({});
  const [itemlist2, setItemlist2] = useState([]);
  const [pms, setPms] = useState([]);
  const [treatmentProcedure, setTreatmentProcedure] = useState([]);
  const [newTreatmentProcedure, setNewTreatmentProcedure] = useState(false);
  const [selectModal, setSelectModal] = useState(false);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  const [treatmentName, setTreatmentName] = useState("");
  const [search, setSearch] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [newKey, setNewKey] = useState(undefined);
  const [uploadKey, setUploadKey] = useState(Math.random());
  const [newTab, setNewTab] = useState(false);
  const [filteredData2, setFilteredData2] = useState([]);
  const [itemize, setItemize] = useState({});
  const [isGettingTreatmentPlans, setIsGettingTreatmentPlans] = useState(true);
  const [optional, setOptional] = useState(false);
  const [modalState, setModalState] = useState({ isVisible: false, deleteId: null });
  const [loading, setLoading] = useState(false);
  const [selectedTreatmentForEducationalContent, setSelectedTreatmentForEducationalContent] = useState(undefined);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showSentDraftLink, setShowSentDraftLink] = useState(false);
  const [sentDraftLink, setSentDraftLink] = useState("");
  const [hasSent, setHasSent] = useState(false); // For checkiing if the user has already sent any treatment or
  const [officeName, setOfficeName] = useState("");
  const [isDeletingProcedure, setIsDeletingProcedure] = useState(false);
  const [showPredeterminationModal, setShowPredeterminationModal] = useState(false);
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  const [activeInsuranceTab, setActiveInsuranceTab] = useState("breakdown");
  const [isDeletingTreatment, setIsDeletingTreatment] = useState(false);
  const [selectedTreatmentPlansForPreview, setSelectedTreatmentPlansForPreview] = useState([]);
  const [isUpdatingPriority, setIsUpdatinPriority] = useState(false);
  const [lastUploadedBreakdown, setLastUploadedBreakdown] = useState(undefined);
  const [isGettingDoctorNote, setIsGettingDoctorNote] = useState(false);
  const [showPatientInsuranceFormModal, setShowPatientInsuranceFormModal] = useState(false);
  const [showEligibility2FAFormModal, setShowEligibility2FAFormModal] = useState(false);
  const [showEligibilityDataModal, setShowEligibilityDataModal] = useState(false);
  const [cancelProcess, setCancelProcess] = useState(false); // To handle how to close the 2fa modal and polify info modal (member_id, insurance_type, contract_number)
  const [editPatientInsuranceData, setEditPatientInsuranceData] = useState(false);
  const [hashedPatientID, setHashedPatientID] = useState(null);
  const [isFilteringProcedures, setIsFilteringProcedures] = useState(false);
  const [predeterminationTreatmentID, setPredeterminationTreatmentID] = useState(undefined);
  const [procedureSearch, setProcedureSearch] = useState("");
  const [procedureSearchValue] = useDebounce(procedureSearch, 1000);
  const [patientPolicies, setPatientPolicies] = useState([]);
  // Page-level attention note so an inline note edit in the breakdown /
  // estimate modal survives close/reopen (the modals use destroyOnClose).
  const [attentionNote, setAttentionNote] = useState(props.data && props.data.manual_attention_note);
  useEffect(
    function () {
      setAttentionNote(props.data && props.data.manual_attention_note);
    },
    [props.data && props.data.manual_attention_note],
  );
  const patientWithNote = props.data ? { ...props.data, manual_attention_note: attentionNote } : props.data;
  // Per-policy note optimistic patch (mirrors TreatmentPlanListRowInsuranceActions):
  // notes now save against a policy id — patch it into patientPolicies so it
  // survives the modal's destroyOnClose.
  function handleModalNoteSaved(policyId, noteOrPatch) {
    if (typeof policyId !== "number") {
      setAttentionNote(typeof policyId === "string" ? policyId : noteOrPatch);
      return;
    }
    const patch = (noteOrPatch && typeof noteOrPatch === "object")
      ? noteOrPatch
      : { attention_note: noteOrPatch || null, attention_note_set_at: new Date().toISOString() };
    setPatientPolicies(function (prev) {
      return (prev || []).map(function (p) {
        return p.id === policyId ? { ...p, ...patch } : p;
      });
    });
  }
  const [showSelectPolicyItemModal, setShowSelectPolicyItemModal] = useState(false);
  const [policyModalInitialMode, setPolicyModalInitialMode] = useState(undefined);
  const [agentType, setAgentType] = useState(undefined);
  const [selectedPolicy, setSelectedPolicy] = useState(undefined);
  const [breakdownEligibilityRefreshTick, setBreakdownEligibilityRefreshTick] = useState(0);

  // PMS data modal
  const [pmsTablePage, setPmsTablePage] = useState(1);
  const [pmsDataType, setPmsDataType] = useState("active");
  const [isGettingPmsData, setIsGettingPmsData] = useState(false);
  const [totalPmsTablePageSize, setTotalPmsTablePageSize] = useState(0);

  // Eligibility scraper agent
  const {
    checkPatientInsuranceEligibility,
    isLoading: isAgentScrappingData,
    eligibilityData,
    breakdownData,
    predeterminationData,
    eligibilityAgentToken,
    predeterminationBatchID, // This is related to predetermination modal
    breakdownModalEligibilityActive,
    agent2FAStatus,
    taskStatus: eligibilityTaskStatus,
  } = useGetPatientInsuranceEligibility(props.data && props.data.id, setShowPatientInsuranceFormModal, setShowEligibility2FAFormModal, cancelProcess, {
    onBreakdownEligibilityComplete: () => setBreakdownEligibilityRefreshTick((n) => n + 1),
  });

  const sentDraftLinkRef = useRef(null);
  const doctorsNoteInput = useRef(null);

  const prevIdRef = useRef();

  const handleProcedureInputChange = (value, procIndex, fieldName) => {
    const updatedValue = value ? value : "";
    setEditedProcedures({
      ...editedProcedures,
      [procIndex]: {
        ...editedProcedures[procIndex],
        [fieldName]: updatedValue,
      },
    });
  };

  // Show the eligibility data modal when the eligibility data is provided
  useEffect(() => {
    if (agentType === "eligibility") {
      if (eligibilityData === undefined) return;
    } else if (agentType === "breakdown") {
      if (breakdownData === undefined) return;
    } else if (agentType === "predetermination") {
      if (predeterminationData === undefined) return;
    }

    if (agentType === "eligibility") {
      setShowEligibilityDataModal(true);
    } else if (agentType === "breakdown") {
      setActiveInsuranceTab("breakdown");
      setShowInsuranceModal(true);
    } else if (agentType === "predetermination") {
      setActiveInsuranceTab("estimates");
      setShowInsuranceModal(true);
    }
  }, [eligibilityData, breakdownData, predeterminationData]);

  // Get the file type (assuming `file.file_type` contains the file type)
  const getFileIcon = (fileType) => {
    switch (fileType) {
      case "pdf":
        return pdfIcon;
      case "msword":
      case "vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "docx":
        return wordIcon;
      case "xlsx":
        return excelIcon;
      case "pptx":
        return powerIcon;
      case "zip":
      case "rar":
        return folder; // Default folder icon for compressed files
      case "mp4":
        return mp4Icon;
      case "mkv":
        return mkvIcon;
      case "aspx":
        return folder; // Assuming folder icon for this type
      default:
        return folder; // Default folder icon for unknown types
    }
  };

  // CHECK
  // Function to save the edited procedure
  const saveEditedProcedure = async (procIndex, record, procedureId) => {
    const expandedRowData = editedProcedures[procIndex]; // Get the edited data for the current procedure

    if (expandedRowData !== undefined) {
      if (record.estimated_cost === "" || record.estimated_cost === undefined || record.estimated_cost === null) {
        if (
          expandedRowData !== undefined &&
          Object.keys(expandedRowData).includes("estimated_cost") &&
          (expandedRowData.estimated_cost === "" || expandedRowData.estimated_cost === null || expandedRowData.estimated_cost === undefined)
        ) {
          notification.error({
            message: "Error",
            description: "Please Fill Estimated Cost.",
            placement: "bottomRight",
          });
          return;
        }
      }

      if (
        expandedRowData !== undefined &&
        Object.keys(expandedRowData).includes("estimated_cost") &&
        (expandedRowData.estimated_cost === "" || expandedRowData.estimated_cost === null || expandedRowData.estimated_cost === undefined)
      ) {
        notification.error({
          message: "Error",
          description: "Please Fill Estimated Cost.",
          placement: "bottomRight",
        });
        return;
      }
    }

    try {
      const dataToSend = {};
      if (expandedRowData && expandedRowData.procedure_code_description) {
        dataToSend.procedure_code = expandedRowData.procedure_code_description;
      }

      if (expandedRowData && expandedRowData.tooth) {
        dataToSend.tooth = expandedRowData.tooth || "-";
      }

      // Make sure that if the discount field exists in the object and it's empty string, then set 0 az the default value, otherwise check if the discount is changed, then set the new discount value
      if (expandedRowData && expandedRowData.discount === "") {
        dataToSend.discount = "0";
      } else if (expandedRowData && expandedRowData.discount) {
        dataToSend.discount = expandedRowData.discount;
      }

      if (expandedRowData && expandedRowData.insurance_estimate !== null && expandedRowData.insurance_estimate !== undefined) {
        dataToSend.insurance_estimate = expandedRowData.insurance_estimate;
      }

      if (expandedRowData && expandedRowData.estimated_cost !== null && expandedRowData.estimated_cost !== undefined) {
        dataToSend.estimated_cost = expandedRowData.estimated_cost;
      }

      // Send data to the server only with the existing fields
      const response = await controller.UpdateProcedures(procedureId, dataToSend);

      if (response.status === 200) {
        // Update local table state after successful response
        setItemlist2((prevItemList) =>
          prevItemList.map((item) =>
            item.key === record.key // Update the specific row that matches the current record
              ? {
                ...item,
                treatment_plans: item.treatment_plans.map((plan) => ({
                  ...plan,
                  treatment_procedures: plan.treatment_procedures.map((procedure, index) =>
                    index === procIndex
                      ? {
                        ...procedure,
                        ...dataToSend, // Only update the fields that were sent
                      }
                      : procedure,
                  ),
                })),
              }
              : item,
          ),
        );
        message.success("Procedure Saved successfully!");

        // Exit edit mode
        setEditingProcedureIndex(null);
        setEditedProcedures({});
        handleReadData2();
        setDisableAdd(false);
      } else {
        console.error("Error updating procedure:", response.message);
        // Optionally, handle server errors here (e.g., display an error message)
        setEditingProcedureIndex(null);
        setEditedProcedures({});
      }
    } catch (error) {
      console.error("Error saving procedure:", error);
      // Handle network or unexpected errors
    }
    setEditingProcedureIndex(null);
    setEditedProcedures({});
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const [form] = Form.useForm();

  // Check if educational_content exists and has at least one item with a video_file array
  const contentExists =
    edulist &&
    edulist.educational_content &&
    edulist.educational_content.length > 0 &&
    edulist.educational_content.some((item) => item.video_file && item.video_file.length > 0);

  // Get the total number of video files if educational_content exists
  const totalPages = contentExists
    ? edulist.educational_content.reduce((total, item) => total + (item.video_file ? item.video_file.length : 0), 0)
    : 0;

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle "Previous" button click
  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleEditModal2 = (id) => {
    setModalEdit2(true);
    setEduId(id);
  };

  // This is for adding a procedure for a new treatment
  const handleAddNewTreatmentProcedure = () => {
    setNewTreatmentProcedure(true);
  };

  const handleAddExistingPro = (id, record) => {
    if (record.treatment) {
      setIsModalVisible3(true);
      setSelectModal(true);
      setTreatmentId(id);
      setTreatmentName(record.name);
    } else {
      notification.error({
        message: "Error",
        description: "Please Fill Treatment Name.",
        placement: "bottomRight",
      });
    }
  };

  const handleAddExistingPro2 = (id, record) => {
    if (record.treatment) {
      setIsModalVisible5(true);
      setSelectModal(true);
      setTreatmentId(id);
      setTreatmentName(record.name);
    } else {
      notification.error({
        message: "Error",
        description: "Please Fill Treatment Name .",
        placement: "bottomRight",
      });
    }
  };

  const updateEducational3 = async () => {
    try {
      const formData = new FormData();
      if (desc2) {
        formData.append("description", desc2);
      }

      if (eduvalue && eduvalue.length > 0) {
        eduvalue.forEach((file) => {
          formData.append("video_file", file);
        });
      } else {
        formData.append("video_file", []);
      }

      await controller.UpdateEducational2(eduid, formData);
      handleCancel();
      handleReadEdu();
      handleEduList();
      setModalEdit2(false);
      message.success("Educational Content updated successfully!");
    } catch (error) {
      console.error("Error updating educational:", error);
      message.error("Failed to update educational Content. Please try again.");
    }
  };

  // const onBack = () => {
  //   props.setCurrentStep(1);
  // };

  const getImageUrl = (file) => {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return file.image_path || URL.createObjectURL(file);
  };

  const handleTextAreaChange = (e) => {
    setNote(e.target.value);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDesc("");
    setEduValue([]);
    setNewTab(false);
    setDesc2("");
    setModalEdit2(false);
  };

  const handleCancel3 = () => {
    setIsModalVisible3(false);
    setSelectedRowKeys2([]);
    setSearch("");
  };

  const handleCancel4 = () => {
    setIsModalVisible5(false);
    setSelectedRowKeys2([]);
    setSearch("");
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);
    setText("");
    setUrl("");
    setName("");
    setVideoFile([]);
    form.resetFields();
  };

  const handleOpen = (record) => {
    setIsModalVisible(true);
    setId(record.key);
    handleReadEdu();
    setCurrentPage(0);
    handleEduList();
  };

  const handleOpen2 = (record) => {
    setIsModalVisible2(true);
  };

  const handleExpandedInputChange = (value, key, field) => {
    // value will be item.id here
    const updatedData = { ...expandedRowInputValues[key], [field]: value }; // Store item.id in 'procedure_code'
    setExpandedRowInputValues({
      ...expandedRowInputValues,
      [key]: updatedData,
    });

    // Send updatedData to the server, and it will contain the correct item.id
  };

  useEffect(() => {
    if (!isExpanded) {
      setNote("");
      setImageFile([]);
    }
  }, [isExpanded]);

  const handleDelete2 = async (imageId, index) => {
    try {
      if (imageId) {
        await controller.removeImages(imageId);
        setImageFile((prevFiles) => prevFiles.filter((file) => file.id !== imageId));
      } else {
        setImageFile((prevFiles) => {
          const updatedFiles = prevFiles.filter((file, i) => i !== index);

          return updatedFiles;
        });
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  // Use `onRemove` for consistent delete behavior
  const handleRemove = async (file) => {
    const fileIndex = imageFile.findIndex((item) => item.name === file.name);
    const imageId = imageFile[fileIndex] ? imageFile[fileIndex].id : null;
    await handleDelete2(imageId, fileIndex);
  };

  const handleUploadChange = (info) => {
    setImageFile((prevFiles) => {
      // Filter out files that do not have `originFileObj`
      const newFiles = info.fileList.map((file) => file.originFileObj).filter((file) => file !== undefined); // Ensure only valid file objects are included

      // Combine new files with previous files, avoiding duplicates based on name and lastModified
      const combinedFiles = [
        ...prevFiles,
        ...newFiles.filter(
          (newFile) => !prevFiles.some((prevFile) => prevFile.name === newFile.name && prevFile.lastModified === newFile.lastModified),
        ),
      ];

      return combinedFiles;
    });
  };

  const handleUploadChange2 = (info) => {
    setVideoFile((prevFiles) => {
      const newFiles = info.fileList.map((file) => file.originFileObj);

      const combinedFiles = [
        ...prevFiles,
        ...newFiles.filter(
          (newFile) => !prevFiles.some((prevFile) => prevFile.name === newFile.name && prevFile.lastModified === newFile.lastModified),
        ),
      ];

      if (newFiles.length > 0) {
        notification.success({
          message: "Success",
          description: `Your file has been uploaded successfully.`,
          placement: "bottomRight",
        });
      }

      return combinedFiles;
    });
  };

  const handleReadData = async () => {
    var id = localStorage.getItem("patient_id")
      ? localStorage.getItem("patient_id")
      : localStorage.getItem("modalSelectId")
        ? localStorage.getItem("modalSelectId")
        : localStorage.getItem("newPatientId");

    // If the patient id does not exists, then get it from patient data (which comes from patient board)
    if (!id) id = props.data.id;

    try {
      setIsGettingDoctorNote(true);

      const response = await controller.getDoctorNote(id);

      if (response.status < 250) {
        const jsonData = await response.json;

        if (jsonData.last_insurance_breakdown) {
          setLastUploadedBreakdown(response.json.last_insurance_breakdown);
        }

        if (jsonData.results.length > 0) {
          const baseUrl = window.location.href.includes("staging") ? "https://fe-staging.smilepass.com/" : "https://app.smilepass.com/";
          const url = `${baseUrl}#/new/treatment-plan/?patient_id=${hashedPatientID}`;

          setSentDraftLink(url);
          setHashedPatientID(jsonData.results[0].encoded_pid);
        }

        if (jsonData.results && jsonData.results.length > 0) {
          // Extract the IDs
          const ids = jsonData.results.map((result) => result.id);

          const largestId = Math.max(...ids);
          const largestIdData = jsonData.results.find((result) => result.id === largestId);

          setData(largestIdData);
          setNote(largestIdData.note);

          if (largestIdData.image_files && largestIdData.image_files.length > 0) {
            const imageData = largestIdData.image_files.map((file) => ({
              path: file.image_path,
              id: file.id,
              name: file.file_name,
            }));
            setImageFile(imageData);
          } else {
            console.error("No image file found in the response");
            setImageFile([]);
          }

          const treatmentIDs = largestIdData.treatment_plans.map((plan) => plan.id);
          setSelectedTreatmentIds(treatmentIDs);
          setSelectedRowKeys(treatmentIDs.map((id) => id.toString()));
        } else {
          console.error("No note found in the response");
          setSave(true);
          setImageFile([]);
        }
      }
    } catch (e) {
      console.error("Error fetching the note:", e);
      // Optionally handle the error, e.g., display a notification
      setImageFile([]); // Ensure imageFile is an empty array if an error occurs
    } finally {
      setIsGettingDoctorNote(false);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleReadData();
    }, 1000); // Adjust the delay time in milliseconds as needed

    return () => clearTimeout(timeout); // Cleanup the timeout on component unmount
  }, []);

  useEffect(() => {
    setSelectedRowKeys(selectedTreatmentIds.map((id) => id.toString()));
  }, [selectedTreatmentIds]);

  const handleReadEdu = async () => {
    try {
      const response = await controller.getEducatinal(0);
      if (response.status < 250) {
        const data = await response.json;
        const results = data;
        setEdu(results);
      }
    } catch (e) {
      console.error(e);
      message.error("Something went wrong while getting educational content");
    }
  };

  const handleReadData2 = async () => {
    // var id = localStorage.getItem("patient_id")
    //   ? localStorage.getItem("patient_id")
    //   : localStorage.getItem("modalSelectId")
    //   ? localStorage.getItem("modalSelectId")
    //   : localStorage.getItem("newPatientId")
    //   ? localStorage.getItem("newPatientId")
    //   : props.newPatientID;
    try {
      setIsGettingTreatmentPlans(true);
      const response = await controller.getTreatmentPlans2(
        "",
        searchQuery2,
        current,
        startDates,
        endDates,
        selectedprocedure,
        props.data.id, // Patient id
        "non-pms-only",
      );

      if (response.status < 250) {
        const data = response.json;

        if (data.results && data.results.length > 0) {
          setItemList(data.results); // Set state with fetched data
          setHasSent(data.results[0].has_sent);
          setOfficeName(data.results[0].office_name);

          if (data.results.length > 0) setSelectedTreatmentIds(data.results[0].treatment_plans.map((tp) => tp.id));

          if (Boolean(data.results[0].has_sent) && hashedPatientID) {
            // const patientId = localStorage.getItem("patient_id");
            const baseUrl = window.location.href.includes("staging") ? "https://fe-staging.smilepass.com/" : "https://app.smilepass.com/";
            const url = `${baseUrl}#/new/treatment-plan/?patient_id=${hashedPatientID}`;

            setSentDraftLink(url);
          }
        }

        // Load policies from the dedicated patient insurance endpoint. Relying only on
        // insurance_policy_ids embedded in list-treatment-by-patient is fragile (missing key,
        // empty array, or serializer issues) and leaves the UI with no policies.
        if (props.data && props.data.id) {
          try {
            const polRes = await rootController.getPatientPolicies(props.data.id);
            if (polRes.status < 250 && Array.isArray(polRes.json)) {
              setPatientPolicies(polRes.json);
            }
          } catch (polErr) {
            console.error("Error loading patient insurance policies:", polErr);
          }
        }
      } else {
        console.error("Response status not OK:", response.status);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
      message.error("Something went wrong while getting treatments data");
    } finally {
      setIsGettingTreatmentPlans(false);
    }
  };

  useEffect(
    function () {
      const baseUrl = window.location.href.includes("staging") ? "https://fe-staging.smilepass.com/" : "https://app.smilepass.com/";
      const url = `${baseUrl}#/new/treatment-plan/?patient_id=${hashedPatientID}`;
      setSentDraftLink(url);
    },
    [hashedPatientID],
  );

  useEffect(
    function () {
      if (!showPredeterminationModal && !showInsuranceModal) handleReadData2();
    },
    [showPredeterminationModal, showInsuranceModal],
  );

  useEffect(() => {
    if (itemlist && Array.isArray(itemlist)) {
      const data = itemlist.filter((user) => user.treatment_plans && user.treatment_plans.some((plan) => selectedTreatmentIds.includes(plan.id)));

      if (data[0]) data[0].note = note;

      setFilteredData2(data);
    }
  }, [itemlist, selectedTreatmentIds, note]);

  // Storing data into localstorage each time a treatment is selected or doctor's note changes to show preview page
  useEffect(() => {
    storePreviewData();
  }, [itemlist, selectedRowKeys, note, tableData]);

  // Like the aboce one, just checking priority request status
  useEffect(() => {
    if (isUpdatingPriority) return;
    storePreviewData();
  }, [isUpdatingPriority]);

  function storePreviewData() {
    if (itemlist && Array.isArray(itemlist) && selectedRowKeys.length > 0) {
      const data = itemlist
        .filter((item) => item.treatment_plans && item.treatment_plans.some((plan) => selectedRowKeys.includes(plan.id.toString())))
        .map((item) => ({
          ...item,
          treatment_plans: item.treatment_plans.filter((plan) => selectedRowKeys.includes(plan.id.toString())),
          priority: item.priority,
        }))
        .sort((a, b) => a.priority - b.priority);

      if (data[0]) data[0].note = note;

      setSelectedTreatmentPlansForPreview(data);
      localStorage.removeItem("previewData");
      localStorage.setItem("previewData", JSON.stringify(data));
    }
  }

  const handlePreviewClick = () => {
    if (
      (selectedTreatmentPlansForPreview.length > 0 && selectedTreatmentPlansForPreview[0].treatment_plans.length === 0) ||
      selectedRowKeys.length === 0
    ) {
      notification.error({
        message: "Error",
        description: "Please Select at least one treatment.",
        placement: "bottomRight",
      });
      return;
    }
    // Save data to localStorage
    localStorage.setItem("filteredData2", JSON.stringify(filteredData2));
    localStorage.setItem("imageFile", JSON.stringify(imageFile)); // Convert to JSON string

    // Open the new tab with the full URL
    const baseUrl = window.location.origin; // Get the base URL of your app
    window.open(`${baseUrl}/#/preview`, "_blank"); // Open the new tab with the correct URL
  };

  useEffect(() => {
    localStorage.removeItem("filteredData2");
    localStorage.removeItem("imageFile");
  }, []);

  const handleReadPmsData = async () => {
    var id = localStorage.getItem("patient_id")
      ? localStorage.getItem("patient_id")
      : localStorage.getItem("modalSelectId")
        ? localStorage.getItem("modalSelectId")
        : localStorage.getItem("newPatientId");

    // If the patient id does not exists, then get it from patient data (which comes from patient board)
    if (!id) id = props.data.id;

    try {
      setIsGettingPmsData(true);

      const response = await controller.getProceduresPms(id, search, pmsTablePage, pmsDataType);

      if (response.status < 250) {
        const data = await response.json;

        setPms(data.results); // Set state with fetched data
        setTotalPmsTablePageSize(data.count);
      } else {
        console.error("Response status not OK:", response.status);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
      message.error("Something went wrong while fetching PMS data");
    } finally {
      setIsGettingPmsData(false);
    }
  };

  const handleEduList = async () => {
    setLoading(true); // Set loading to true
    try {
      const response = await controller.getEduByPatient(id);

      if (response.status < 250) {
        const data = await response.json;
        setEduList(data); // Set state with fetched data
        setDesc2(data.educational_content[0].description);
      } else {
        console.error("Response status not OK:", response.status);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
    } finally {
      setLoading(false); // Ensure loading is false after operation completes
    }
  };

  useEffect(() => {
    async function getTreatmentData() {
      await rootController.syncPMSDataModal(props.data.id);
      handleReadData2();
    }
    getTreatmentData();
  }, []);

  useEffect(() => {
    if (debounceTimeout) clearTimeout(debounceTimeout);

    const newTimeout = setTimeout(() => {
      handleReadPmsData();
    }, 2000);

    setDebounceTimeout(newTimeout);

    return () => clearTimeout(newTimeout);
  }, [search, pmsTablePage, pmsDataType]);

  useEffect(() => {
    // Check if id exists and is different from the previous id
    if (id && id !== prevIdRef.current) {
      const timeoutId = setTimeout(() => {
        handleEduList();
      }, 500);

      prevIdRef.current = id;

      return () => clearTimeout(timeoutId);
    }
  }, [id]);

  useEffect(() => {
    processTreatmentPlans(); // This will log the updated itemlist when it changes
  }, [itemlist]);

  const handleReadProcuders = async () => {
    try {
      const response = await controller.getProcedure(0, "");
      if (response.status < 250) {
        const data = await response.json;
        const results = data;
        setProcedures(results);
      }
    } catch (e) {
      console.error(e);
      message.error("Something went wrong while getting procedures");
    }
  };

  useEffect(() => {
    handleReadProcuders();
    handleReadEdu();
  }, []);

  const handleSuccessAddToServer = () => {
    props.updateData();
  };

  const processTreatmentPlans = () => {
    // Check if itemlist has at least one object and then access its treatment_plans
    if (itemlist.length > 0 && itemlist[0].treatment_plans && Array.isArray(itemlist[0].treatment_plans) && itemlist[0].treatment_plans.length > 0) {
      const treatmentPlans = itemlist[0].treatment_plans.map((plan) => ({
        key: plan.id.toString(), // Assuming each plan has a unique 'id'
        treatment: plan.name || "-", // Assuming each plan has a 'name' field
        estimatedCost: plan.estimated_cost !== undefined && plan.estimated_cost !== null ? plan.estimated_cost : "", // Optional field
        insuranceCoverage: plan.insurance_coverage, // Optional field
        tooth_from: plan.tooth_from || "-", // Optional field
        priority: plan.priority || 0, // Optional field
        procedure: plan.procedure ? plan.procedure.name : "-", // Optional nested field
        discount: plan.discount || 0, // Optional field
        patientResponsibility: plan.patient_responsibility !== undefined && plan.patient_responsibility !== null ? plan.patient_responsibility : "-",
        provider: plan.provider || "-",
        surface: plan.surface || "-",
        treatmentProcedures: plan.treatment_procedures.length, // Get the treatment procedures for identify that estimate const, insurance estimate and discount for a treatment can be edited or not
      }));

      // Set the transformed treatment plans to your table
      setTableData(treatmentPlans);

      // Initialize the edit state based on the keys of the treatment plans
      const initialEditState = {};
      treatmentPlans.forEach((row) => {
        initialEditState[row.key] = false;
      });
      setEditState(initialEditState);
    } else {
      console.error("No treatment plans available. Debugging info:");
      console.error("Itemlist:", itemlist);
      console.error("Treatment Plans:", itemlist[0] ? itemlist[0].treatment_plans : "None");
      setTableData([]);
    }
  };

  useEffect(() => {
    if (itemlist) {
      processTreatmentPlans();
    }
  }, [itemlist]);

  const tableRef = useRef(null); // Reference for the table container

  // Handle input change for editable fields
  const addTreatmentPlan = () => {
    const key = Date.now().toString();
    const newRow = {
      key,
      treatment: "",
      estimatedCost: "",
      insuranceCoverage: "",
      notes: "",
      priority: "",
      procedure: "",
      isNew: true, // Flag new rows
    };

    setDisableAdd(true);
    setNewKey(key);

    // Append the new row to the end of the tableData array
    setTableData((prevTableData) => [...prevTableData, newRow]);
    setEditState((prevEditState) => ({ ...prevEditState, [newRow.key]: true }));
    setExpandedRowKeys((prevExpandedRowKeys) => [...prevExpandedRowKeys, newRow.key]);

    // Auto-scroll to the bottom of the table
    setTimeout(() => {
      if (tableRef.current) {
        tableRef.current.scrollTo({
          top: tableRef.current.scrollHeight,
          behavior: "smooth", // Smooth scrolling
        });
      }
    }, 500);
  };

  // Handle input change for editable fields
  const handleInputChange = (e, key, field) => {
    const newValue = e.target.value;
    const newData = [...tableData];
    const index = newData.findIndex((item) => item.key === key);
    if (index > -1) {
      const item = newData[index];
      item[field] = newValue; // Update the specific field
      setTableData(newData);
    }
  };

  const handleEdit = (record) => {
    const updatedEditState = { ...edit, [record.key]: !edit[record.key] };
    setEdit(updatedEditState);
  };

  const cancelEdit = async (record) => {
    const result = await saveNotesToServer(record);
    if (result === false) return;

    const updatedEditState = { ...edit, [record.key]: !edit[record.key] };
    setEdit(updatedEditState);
  };

  const saveNotesToServer = async (record) => {
    try {
      // Treatment name cannot be empty
      if (record.treatment === "") {
        notification.error({
          message: "Error",
          description: "Please fill treatment name.",
          placement: "bottomRight",
        });
        return false;
      }

      // Estimate cost cannot be empty
      if (record.treatmentProcedures === 0 && record.estimatedCost === "") {
        notification.error({
          message: "Error",
          description: "Please fill Estimate cost.",
          placement: "bottomRight",
        });
        return false;
      }

      const updatedTreatmentData = await controller.UpdateTreatmentPlans(record.key, {
        tooth_from: record.tooth_from,
        name: record.treatment,
        discount: record.discount !== "" ? Number(record.discount) : 0,
        estimated_cost: record.estimatedCost,
        insurance_coverage: record.insuranceCoverage,
      });

      // Updating patient responsibility field
      const updatedTableData = tableData.map((row) => {
        if (row.key === record.key) {
          return { ...row, patientResponsibility: updatedTreatmentData.json.patient_responsibility, discount: updatedTreatmentData.json.discount };
        }
        return row;
      });
      setTableData(updatedTableData);

      // props.updateDataUpdatePriority();
    } catch (error) {
      message.error("Something went wrong while editing treatment");
      console.error("Error updating notes:", error);
    } finally {
      setDisableAdd(false);
    }
  };

  const savePriorityToServer = async (record) => {
    setUpdatingPriority(record.key);
    try {
      console.log(record);
      setIsUpdatinPriority(true);
      await controller.UpdateTreatmentPlans(record.key, { priority: record.priority });
      setTableData((prevTableData) => prevTableData.map((row) => (row.key === record.key ? { ...row, priority: record.priority } : row)));
      // Update the itemlist state to store the updated data into localStorage for preview page
      setItemList((prevItemList) =>
        prevItemList.map((item) => ({
          ...item,
          treatment_plans: item.treatment_plans.map((plan) => (plan.id.toString() === record.key ? { ...plan, priority: record.priority } : plan)),
        })),
      );
      // props.updateDataUpdatePriority();
    } catch (error) {
      console.error("Error updating priority:", error);
      message.error("Something went wrong while updating priority");
    } finally {
      setIsUpdatinPriority(false);
      setDisableAdd(false);
    }
    setTimeout(() => {
      setUpdatingPriority(null);
    }, 800);
  };

  const saveTreatmentPlanToServeraddProcedure = async (record, recordKey) => {
    const expandedRowData = expandedRowInputValues[recordKey];

    if (!record.treatment) {
      notification.error({
        message: "Error",
        description: "Please fill Treatment Name.",
        placement: "bottomRight",
      });
      return;
    }

    const { tooth_from, discount, insuranceCoverage, estimatedCost } = tableData.find((item) => item.key === recordKey);

    // Check if expandedRowData exists before accessing estimated_cost
    if (!estimatedCost && !itemize[record.key]) {
      notification.error({
        message: "Error",
        description: "Please fill Estimated Cost.",
        placement: "bottomRight",
      });
      return;
    }

    const treatmentProcedureData = {};

    // Check if the itemized checkbox is marked, if so, only the treatment and tooth data must be send (with procedure code or without procedure code)
    if (!itemize[record.key]) {
      treatmentProcedureData.tooth_from = tooth_from;
      treatmentProcedureData.discount = discount;
      treatmentProcedureData.insurance_coverage = insuranceCoverage;
      treatmentProcedureData.estimated_cost = estimatedCost;
    }

    // Getting procedure data from expanded row for creating a treatment with procedure
    if (expandedRowData) {
      if (expandedRowData.procedure_code) treatmentProcedureData.procedure_code = expandedRowData.procedure_code;
      if (expandedRowData.tooth_quad) treatmentProcedureData.tooth = expandedRowData.tooth_quad;
      if (expandedRowData.discount) treatmentProcedureData.discount = expandedRowData.discount ? expandedRowData.discount : "0";
      if (expandedRowData.insurance_estimate) treatmentProcedureData.insurance_estimate = expandedRowData.insurance_estimate;
      if (expandedRowData.estimated_cost) treatmentProcedureData.estimated_cost = expandedRowData.estimated_cost;
    }

    treatmentProcedureData.insurance_estimate = expandedRowData && expandedRowData.insurance_estimate;
    treatmentProcedureData.discount = expandedRowData && expandedRowData.discount ? expandedRowData.discount : "0";

    if (selectedRowKeys2 && selectedRowKeys2.length > 0) {
      treatmentProcedureData.treatment_procedure_ids = selectedRowKeys2;
    }

    // Check if procedure code is selected
    if (itemize[record.key] && !treatmentProcedureData.procedure_code) {
      notification.error({ message: "Error", description: "Please Select Procedure Code.", placement: "bottomRight" });
      return;
    }

    // Show error if Estimate cost does not exist or is empty or it' not a number
    if (itemize[record.key] && (treatmentProcedureData.estimated_cost === undefined || treatmentProcedureData.estimated_cost === "")) {
      notification.error({ message: "Error", description: "Please Fill Estimated Cost.", placement: "bottomRight" });
      return;
    }

    // Check if the Estimate Cost is a number
    if (isNaN(treatmentProcedureData.estimated_cost)) {
      notification.error({ message: "Error", description: "Estimated Cost Must be a Number.", placement: "bottomRight" });
      return;
    }

    if (Object.keys(treatmentProcedureData).length > 0 || selectedRowKeys2.length > 0) {
      setLoading(true); // Set loading to true
      try {
        const dataToSend = {
          name: record.treatment,
          patient: localStorage.getItem("patient_id")
            ? localStorage.getItem("patient_id")
            : localStorage.getItem("modalSelectId")
              ? localStorage.getItem("modalSelectId")
              : localStorage.getItem("newPatientId"),
        };
        let response;

        if (record.isNew && itemize[record.key]) {
          dataToSend.treatment_procedure_data = treatmentProcedureData;
          dataToSend.tooth_from = record.tooth_from;
          dataToSend.discount = discount ? discount : "0";
          dataToSend.tooth_from = tooth_from;
          dataToSend.estimated_cost = estimatedCost;
          dataToSend.insurance_coverage = insuranceCoverage ? insuranceCoverage : "0";
          response = await controller.createTreatmentPlanAndProcedure(dataToSend);
        } else {
          dataToSend.discount = discount ? discount : "0";
          dataToSend.tooth_from = tooth_from;
          dataToSend.estimated_cost = estimatedCost;
          dataToSend.insurance_coverage = insuranceCoverage ? insuranceCoverage : "0";

          response = await controller.createTreatmentPlans(dataToSend);
        }

        if (response.status < 250) {
          message.success("Treatment plan created successfully!");
        }

        // Handling procedures after creating treatment with procedure
        const treatmentProcedures = treatmentProcedure.filter((procedure) => procedure !== record.key);

        setTableData((prevTableData) => prevTableData.map((row) => (row.key === record.key ? { ...row, ...record } : row)));
        processTreatmentPlans();
        setDisableAdd(false);
        handleReadData2();
        setNewKey(undefined);
        setIsModalVisible3(false);
        setSelectedRowKeys2([]);
        setTreatmentProcedure((prevState) => [...prevState, treatmentProcedures]);
        setNewTreatmentProcedure(false);

        setExpandedRowInputValues((prevValues) => ({
          ...prevValues,
          [recordKey]: {
            procedure_code: "",
            tooth_quad: "",
            discount: "",
            insurance_estimate: "",
            estimated_cost: "",
          },
        }));

        props.handleReadData2();
        processTreatmentPlans();
      } catch (error) {
        console.error("Error saving treatment plan:", error);
      } finally {
        setLoading(false); // Reset loading to false after completion
      }
    } else {
      console.error("No treatment procedure data or selectedRowKeys2 to send.");
    }
  };
  const saveTreatmentPlanToServer = async (record, recordKey) => {
    const expandedRowData = expandedRowInputValues[recordKey];

    if (!record.treatment) {
      notification.error({
        message: "Error",
        description: "Please fill Treatment Name.",
        placement: "bottomRight",
      });
      return;
    }

    const { tooth_from, discount, insuranceCoverage, estimatedCost } = tableData.find((item) => item.key === recordKey);

    // Check if expandedRowData exists before accessing estimated_cost
    if (!estimatedCost && !itemize[record.key]) {
      notification.error({
        message: "Error",
        description: "Please fill Estimated Cost.",
        placement: "bottomRight",
      });
      return;
    }

    const treatmentProcedureData = {};

    // Check if the itemized checkbox is marked, if so, only the treatment and tooth data must be send (with procedure code or without procedure code)

    if (!itemize[record.key]) {
      treatmentProcedureData.tooth_from = tooth_from;
      treatmentProcedureData.discount = discount;
      treatmentProcedureData.insurance_coverage = insuranceCoverage;
      treatmentProcedureData.estimated_cost = estimatedCost;
    }

    console.log(tableData.find((item) => item.key === recordKey));
    console.log("procedure data 1", treatmentProcedureData);

    if (expandedRowData) {
      if (expandedRowData.procedure_code) treatmentProcedureData.procedure_code = expandedRowData.procedure_code;
      if (expandedRowData.tooth_quad) treatmentProcedureData.tooth = expandedRowData.tooth_quad;
      if (expandedRowData.discount) treatmentProcedureData.discount = expandedRowData.discount || "0";
      if (expandedRowData.insurance_estimate) treatmentProcedureData.insurance_estimate = expandedRowData.insurance_estimate;
      if (expandedRowData.estimated_cost) treatmentProcedureData.estimated_cost = expandedRowData.estimated_cost;
    }
    console.log("procedure data 2", treatmentProcedureData);
    treatmentProcedureData.insurance_estimate = expandedRowData && expandedRowData.insurance_estimate;
    treatmentProcedureData.discount = (expandedRowData && expandedRowData.discount) || "0";
    if (selectedRowKeys2 && selectedRowKeys2.length > 0) {
      treatmentProcedureData.treatment_procedure_ids = selectedRowKeys2;
    }
    console.log("procedure data 3", treatmentProcedureData);

    if (Object.keys(treatmentProcedureData).length > 0 || selectedRowKeys2.length > 0) {
      setLoading(true); // Set loading to true
      try {
        const dataToSend = {
          name: record.treatment,
          patient: localStorage.getItem("patient_id")
            ? localStorage.getItem("patient_id")
            : localStorage.getItem("modalSelectId")
              ? localStorage.getItem("modalSelectId")
              : localStorage.getItem("newPatientId"),
          optional,
        };
        let response;

        // Creating itemized treatment
        if (record.isNew && itemize[record.key]) {
          dataToSend.treatment_procedure_data = treatmentProcedureData;
          dataToSend.tooth_from = record.tooth_from;
          dataToSend.discount = discount;
          dataToSend.tooth_from = tooth_from;
          dataToSend.estimated_cost = estimatedCost;
          dataToSend.insurance_coverage = insuranceCoverage;

          response = await controller.createTreatmentPlanAndProcedure(dataToSend);
        } else {
          // Creating nonitemized treatment
          dataToSend.discount = discount ? discount : "0";
          dataToSend.tooth_from = tooth_from;
          dataToSend.estimated_cost = estimatedCost;
          dataToSend.insurance_coverage = insuranceCoverage;

          response = await controller.createTreatmentPlans(dataToSend);
        }

        if (response.status < 250) {
          message.success("Treatment plan created successfully!");
        }

        // Handling procedures after creating treatment with procedure
        const treatmentProcedures = treatmentProcedure.filter((procedure) => procedure !== record.key);

        setTableData((prevTableData) => prevTableData.map((row) => (row.key === record.key ? { ...row, ...record } : row)));
        processTreatmentPlans();
        setDisableAdd(false);
        handleReadData2();
        setNewKey(undefined);
        setIsModalVisible3(false);
        setSelectedRowKeys2([]);
        setTreatmentProcedure((prevState) => [...prevState, treatmentProcedures]);
        setNewTreatmentProcedure(false);

        setExpandedRowInputValues((prevValues) => ({
          ...prevValues,
          [recordKey]: {
            procedure_code: "",
            tooth_quad: "",
            discount: "",
            insurance_estimate: "",
            estimated_cost: "",
          },
        }));

        props.handleReadData2();
        processTreatmentPlans();
      } catch (error) {
        console.error("Error saving treatment plan:", error);
      } finally {
        setLoading(false); // Reset loading to false after completion
      }
    } else {
      console.error("No treatment procedure data or selectedRowKeys2 to send.");
    }
  };

  const postProcedure = async (record, recordKey) => {
    const treatmentId = Number(recordKey);
    const expandedRowData = expandedRowInputValues[treatmentId];

    if (!expandedRowData) {
      notification.error({
        message: "Error",
        description: "Please Fill Inputs.",
        placement: "bottomRight",
      });
      return;
    }

    if (!expandedRowData.procedure_code) {
      notification.error({
        message: "Error",
        description: "Please select Procedure Code",
        placement: "bottomRight",
      });
      return;
    }

    if (!expandedRowData.estimated_cost) {
      notification.error({
        message: "Error",
        description: "Please Fill Estimated Cost",
        placement: "bottomRight",
      });
      return;
    }

    const procedureData = {
      procedure_code: expandedRowData.procedure_code || "",
      treatment: treatmentId,
      insurance_estimate: expandedRowData.insurance_estimate,
      estimated_cost: expandedRowData.estimated_cost || "",
    };

    if (expandedRowData.tooth_quad) {
      procedureData.tooth = expandedRowData.tooth_quad;
    }
    if (expandedRowData.discount) {
      procedureData.discount = expandedRowData.discount || "0";
    } else {
      procedureData.discount = procedureData.discount || "";
    }

    try {
      setLoading(true);
      await controller.createProcedures(procedureData);

      setTableData((prevTableData) =>
        prevTableData.map((row) =>
          row.key === record.key
            ? {
              ...row,
              procedure_code: expandedRowData.procedure_code,
              tooth_quad: expandedRowData.tooth_quad,
              discount: expandedRowData.discount,
              insurance_estimate: expandedRowData.insurance_estimate,
              estimated_cost: expandedRowData.estimated_cost,
            }
            : row,
        ),
      );
      // Handling procedures after creating treatment with procedure

      message.success("Procedure created successfully!");
      // handleReadData();

      setTimeout(() => {
        const filterItems = treatmentProcedure.filter((procedure) => procedure !== record.key);
        setTreatmentProcedure(filterItems);
      }, 800);
      handleReadData2();
      processTreatmentPlans();
      setDisableAdd(false);
      // setTreatmentProcedure(prevState => [...prevState, treatmentProcedures]);
      setNewTreatmentProcedure(false);

      setExpandedRowInputValues((prevValues) => ({
        ...prevValues,
        [treatmentId]: {
          procedure_code: "",
          tooth_quad: "",
          discount: "",
          insurance_estimate: "",
          estimated_cost: "",
        },
      }));
      setLoading(false);
    } catch (error) {
      setNewTreatmentProcedure(false);
      console.error("Error saving procedure:", error);
      message.error("Failed to create procedure. Please try again.");
    } finally {
      const treatmentProcedures = treatmentProcedure.filter((procedure) => procedure !== record.key);
      setTreatmentProcedure((prevState) => [...prevState, treatmentProcedures]);
    }
  };

  const postEducational = async () => {
    const formData = new FormData();

    try {
      if (videoFile && videoFile.length > 0) {
        videoFile.forEach((file) => {
          formData.append("video", file);
        });
      }
      formData.append("name", name);
      formData.append("link", url);
      formData.append("description", text);
      formData.append("redirect", isChecked);

      await controller.createEducational(formData);

      handleReadEdu();
      message.success("Educational created successfully!");
      handleCancel2();
    } catch (error) {
      console.error("Error saving educational:", error);
      message.error("Failed to create educational. Please try again.");
    }
  };

  const postExistingPro = async () => {
    const formData = new FormData();

    setLoading(true); // Set loading to true at the start
    try {
      if (selectedRowKeys2 && selectedRowKeys2.length > 0) {
        selectedRowKeys2.forEach((id) => {
          formData.append("treatment_procedure_ids", id);
        });
      }
      formData.append("treatment_id", treatmentId);

      await controller.postExistingPro(formData);

      handleReadData2();
      setIsModalVisible3(false);
      setSearch("");

      message.success("Procedures created successfully!");
      handleCancel3();
      handleCancel4();
    } catch (error) {
      console.error("Error saving procedures:", error);
      message.error("Failed to create Procedures. Please try again.");
    } finally {
      setLoading(false); // Reset loading to false after completion
    }
  };

  const handleDelete = async (record) => {
    try {
      setIsDeletingTreatment(true);
      await controller.RemoveTreatmentPlans(record.key);
      const updatedTableData = tableData.filter((row) => row.key !== record.key);
      setTableData(updatedTableData);

      // Update selectedRowKeys
      setSelectedRowKeys((prevKeys) => prevKeys.filter((key) => key !== record.key));

      // Update selectedTreatmentIds
      setSelectedTreatmentIds((prevIds) => prevIds.filter((id) => id !== parseInt(record.key, 10)));

      handleReadData2();
      processTreatmentPlans();
      setDisableAdd(false);
    } catch (error) {
      console.error("Error deleting treatment plan:", error);
    } finally {
      setIsDeletingTreatment(false);
    }
  };

  const deleteProcedures = async (id) => {
    try {
      setIsDeletingProcedure(true);
      await controller.RemoveProcedures(id);
      const updatedTableData = tableData.filter((row) => row.key !== id);
      setTableData(updatedTableData);
      handleReadData2();
      processTreatmentPlans();
      setDisableAdd(false);
    } catch (error) {
      console.error("Error deleting treatment plan:", error);
    } finally {
      setIsDeletingProcedure(false);
    }
  };

  // useEffect(function () {
  //   async function getPatientPolicies() {
  //     try {
  //       const response = await rootController.getPatientPolicies(props.data.id);
  //       console.log(response);
  //     } catch (error) {
  //       message.error("Something went wrong while calling getPatientPolicies");
  //       console.error(error);
  //     }
  //   }
  //   getPatientPolicies();
  // }, []);

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (newSelectedRowKeys) => {
  //     setSelectedRowKeys(newSelectedRowKeys);
  //     const ids = newSelectedRowKeys.map((key) => parseInt(key, 10));
  //     setSelectedTreatmentIds(ids);
  //   },
  //   getCheckboxProps: (record) => ({
  //     disabled: record.key === newKey, // Column configuration not to be checked
  //   }),
  // };

  const hasVideo =
    edulist &&
    edulist.educational_content &&
    edulist.educational_content[0] &&
    edulist.educational_content[0].video_file &&
    edulist.educational_content[0].video_file.length > 0;

  // Get the current video details
  const currentVideo = hasVideo ? edulist.educational_content[0].video_file[currentPage] || {} : {};
  const videoLink = currentVideo.link;

  // Determine video type
  const isYouTube = videoLink && videoLink.includes("youtube.com");
  const isSpearEdu = videoLink && videoLink.includes("spearedu.co");
  const isPatientApi = videoLink && videoLink.includes("patient-api.speareducation.com");

  // Handle redirection logic when currentVideo changes
  useEffect(() => {
    if (currentVideo.redirect && videoLink) {
      setNewTab(true);
    }
  }, [currentVideo.redirect, videoLink]);

  // Reset newTab when the modal is opened
  useEffect(() => {
    if (isModalVisible) {
      setNewTab(false);
    }
  }, [isModalVisible]);

  const handleApprove2 = async (status) => {
    if (selectedTreatmentIds.length === 0) {
      notification.error({
        message: "Error",
        description: "Please select at least one treatment plan.",
        placement: "bottomRight",
      });
      return;
    }

    if (note === "") {
      notification.error({
        message: "Error",
        description: "Please Write Note",
        placement: "bottomRight",
      });
      return;
    }

    try {
      if (save) {
        setIsLoading1(true);
        const formData = new FormData();

        for (var i in selectedTreatmentIds) {
          formData.append("treatment_plans", selectedTreatmentIds[i]);
        }

        formData.append("note", note);
        formData.append("optional", optional);
        formData.append(
          "patient",
          props.data && props.data.id // Check if props.data is truthy before accessing id
            ? props.data.id
            : localStorage.getItem("modalSelectId")
              ? localStorage.getItem("modalSelectId")
              : localStorage.getItem("newPatientId"),
        );

        console.log(imageFile);
        imageFile.forEach(async (file, index) => {
          if (file instanceof File || file instanceof Blob) {
            formData.append(`image_files`, file);
          }
        });

        formData.append("optional", optional);

        localStorage.setItem("filteredData2", formData);

        const response = await controller.postNoteAndImage(formData, status);

        if (response.status < 250) {
          notification.success({
            message: "Success",
            description: "Data Updated Successfully.",
            placement: "bottomRight",
          });

          setIsExpanded(false);
          setIsLoading1(false);
          setSave(false);
          setData(response.json);
          handleReadData();

          // Creating the URL based on project environment
          // const patientId = localStorage.getItem("patient_id");
          const baseUrl = window.location.href.includes("staging") ? "https://fe-staging.smilepass.com/" : "https://app.smilepass.com/";
          const url = `${baseUrl}#/new/treatment-plan/?patient_id=${hashedPatientID}`;

          setSentDraftLink(url);
          console.log("has sent 1", response);
          setHasSent(response.json.has_sent);
        }
      } else {
        setIsLoading(true);

        const formData = new FormData();

        for (var j in selectedTreatmentIds) {
          formData.append("treatment_plans", selectedTreatmentIds[j]);
        }

        formData.append("note", note);
        formData.append("optional", optional);
        // formData.append("patient", props.data.id);
        imageFile.forEach((file, index) => {
          if (file instanceof File || file instanceof Blob) {
            formData.append(`image_files`, file);
          }
        });
        formData.append("optional", optional);
        formData.append("status", status);

        const response = await controller.UpdateDoctorNote(formData, data.id);

        if (response.status < 250) {
          await response.json;

          notification.success({
            message: "Success",
            description: "Data Updated Successfully.",
            placement: "bottomRight",
          });

          // Creating the URL based on project environment
          // const patientId = localStorage.getItem("patient_id");
          const baseUrl = window.location.href.includes("staging") ? "https://fe-staging.smilepass.com/" : "https://app.smilepass.com/";
          const url = `${baseUrl}#/new/treatment-plan/?patient_id=${hashedPatientID}`;

          setSentDraftLink(url);
          setShowSentDraftLink(response.json.status === "sent");
          setIsExpanded(false);
          setIsLoading1(false);
          setHasSent(response.json.has_sent);
          handleReadData();
        }
        setIsLoading1(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error occurred during operation:", error);
      setIsLoading1(false);
      setIsLoading(false);
    }
  };

  const updateEducational = async () => {
    try {
      const formData = new FormData();
      formData.append("description", desc);

      formData.append("treatment", id);

      eduvalue.forEach((value) => {
        const pk = parseInt(value, 10);

        if (!isNaN(pk)) {
          formData.append("video_file", pk);
        } else {
          console.error(`Invalid PK value: ${value}`);
        }
      });

      await controller.UpdateEducational(formData);
      // Update the itemlist state to store the updated data into localStorage for preview page
      setItemList((prevItemList) =>
        prevItemList.map((item) => ({
          ...item,
          treatment_plans: item.treatment_plans.map((plan) =>
            plan.id.toString() === id.toString()
              ? {
                ...plan,
                educational_content: [
                  {
                    ...(plan.educational_content && plan.educational_content[0]),
                    description: desc,
                    video_file: eduvalue.map((val) => edu.find((e) => e.id === val)),
                  },
                ],
              }
              : plan,
          ),
        })),
      );
      handleCancel();
      handleReadEdu();
      message.success("Educational Content updated successfully!");
    } catch (error) {
      console.error("Error updating educational:", error);
      message.error("Failed to update educational Content. Please try again.");
    }
  };

  const handleSaveTreatment = async (record) => {
    try {
      setIsLoading(true);
      await saveTreatmentPlanToServer(record, record.key);
      setItemize((prev) => ({ ...prev, [record.key]: false }));
    } catch (err) {
      console.error("Error saving treatment: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExpandTable = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([...expandedRowKeys, record.key]);
    } else {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key !== record.key));
    }
  };

  const handleChangeProcedureSearch = async (input, option) => {
    console.log(input, option);
    setProcedureSearch(input); // Update the search input state
  };

  // Effect to handle debounced procedure search
  useEffect(() => {
    const fetchProcedures = async () => {
      let procedureCode = "";
      let procedureDescription = "";

      // Check if input is valid
      if (typeof procedureSearchValue !== "string" || !procedureSearchValue) {
        procedureDescription = procedureSearchValue || "";
      } else {
        // Extract numbers using regex
        const numberMatch = procedureSearchValue.match(/\d+/g);

        if (numberMatch) {
          // Join all number sequences for procedureCode
          procedureCode = numberMatch.join("");
          // Remove all numbers from input to get description
          procedureDescription = procedureSearchValue.replace(/\d+/g, "").trim();
          // Clean up any leading/trailing hyphens or spaces
          procedureDescription = procedureDescription.replace(/^-+|-+$/g, "").trim();
        } else {
          // If no numbers, entire input is description
          procedureDescription = procedureSearchValue.trim();
        }
      }

      try {
        setIsFilteringProcedures(true);
        const response = await controller.getProcedure(0, { procedureCode, procedureDescription });
        if (response.status < 250) {
          const data = await response.json;
          setProcedures(data); // Update procedures state with fetched data
        } else {
          message.error("Failed to fetch procedures");
        }
      } catch (err) {
        message.error("Something went wrong while filtering procedures");
        console.error(err);
      } finally {
        setIsFilteringProcedures(false);
      }
    };

    fetchProcedures();
    // if (procedureSearchValue !== "") {
    // }
  }, [procedureSearchValue]);

  useEffect(
    function () {
      if (note === "" && officeName) {
        const suggestion = `Hi ${patientName ? patientName : props.data && props.data.first_name
          }, Your personalized treatment plan, which includes the cost estimate, payment options, treatment simulation, and educational content, is now ready for your review. If you have any questions or need further assistance, our friendly staff is here to help. Best regards, The ${officeName} Team`;

        setNote(suggestion);
      }
    },
    [note, officeName],
  );

  function handleScraperAgentCall(agentType) {
    setCancelProcess(false);
    setAgentType(agentType);
    if (patientPolicies.length === 1) {
      checkPatientInsuranceEligibility(agentType, patientPolicies[0].id);
    } else {
      setShowSelectPolicyItemModal(true);
    }
  }

  // Defining the width of columns
  const columnWidths = {
    priority: 80,
    treatment: 230,
    tooth: 120,
    procedure_code_description: 300,
    estimated_cost: 170,
    insurance_estimate: 140,
    discount: 100,
    patient_responsibility: 150,
    actions: 100,
    action: 130,
  };

  const columns3 = [
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: columnWidths.priority,
      render: function (priority, record) {
        return (
          <Priority
            disabled={newKey === record.key}
            loading={record.key !== updatingPriority ? false : true}
            initialPriority={priority}
            onUpdate={(newPriority, record) => savePriorityToServer({ ...record, priority: newPriority })}
            record={record}
          />
        );
      },
    },
    {
      title: "Treatment",
      dataIndex: "treatment",
      key: "treatment",
      width: columnWidths.treatment,
      render: function (text, record) {
        if (editState[record.key]) {
          return (
            <Input
              value={record.treatment}
              onChange={function (e) {
                handleInputChange(e, record.key, "treatment");
              }}
              placeholder="Treatment"
            />
          );
        } else if (edit[record.key]) {
          return (
            <Input
              value={record.treatment}
              onChange={function (e) {
                handleInputChange(e, record.key, "treatment");
              }}
              placeholder="Treatment"
            />
          );
        } else {
          return text;
        }
      },
    },
    {
      title: "Tooth/Quad",
      dataIndex: "tooth_from",
      key: "tooth_from",
      width: columnWidths.tooth,
      render: function (text, record) {
        if (editState[record.key]) {
          return (
            <Input
              value={record.tooth_from}
              onChange={function (e) {
                handleInputChange(e, record.key, "tooth_from");
              }}
              placeholder="Tooth/Quad"
            />
          );
        } else if (edit[record.key]) {
          return (
            <Input
              value={record.tooth_from}
              onChange={function (e) {
                handleInputChange(e, record.key, "tooth_from");
              }}
              placeholder="Tooth/Quad"
            />
          );
        } else {
          return text;
        }
      },
    },
    {
      title: "Estimated Cost",
      dataIndex: "estimatedCost",
      key: "estimatedCost",
      width: columnWidths.estimated_cost,
      render: function (text, record) {
        if (record.isNew) {
          if (itemize[record.key]) {
            return null;
          }

          return (
            <Input
              placeholder="Cost"
              style={{ width: "100%" }}
              value={record.estimatedCost || ""}
              onChange={(e) => handleInputChange(e, record.key, "estimatedCost")}
            />
          );
        } else if (edit[record.key]) {
          var flag = 0;
          for (var item in itemlist) {
            for (var my_item in itemlist[item].treatment_plans) {
              if (record.key + "" === itemlist[item].treatment_plans[my_item].id + "") {
                if (itemlist[item].treatment_plans[my_item].treatment_procedures.length > 0) {
                  flag = 1;
                }
              }
            }
          }
          if (flag === 1) {
            return text;
          } else {
            return (
              <Input
                placeholder="Cost"
                style={{ width: "100%" }}
                value={record.estimatedCost || ""}
                onChange={(e) => handleInputChange(e, record.key, "estimatedCost")}
              />
            );
          }
        } else {
          return text === null || text === undefined || text === "" ? "$0" : `$${text}`;
        }
      },
    },
    {
      title: "Insurance Estimate",
      dataIndex: "insuranceCoverage",
      key: "insuranceCoverage",
      width: columnWidths.insurance_estimate,
      render: function (text, record) {
        if (record.isNew) {
          if (itemize[record.key]) {
            return null;
          }

          return (
            <Input
              placeholder="Insurance"
              style={{ width: "100%" }}
              value={record.insuranceCoverage || ""}
              onChange={(e) => handleInputChange(e, record.key, "insuranceCoverage")}
            />
          );
        } else if (edit[record.key]) {
          var flag = 0;
          for (var item in itemlist) {
            for (var my_item in itemlist[item].treatment_plans) {
              if (record.key + "" === itemlist[item].treatment_plans[my_item].id + "") {
                if (itemlist[item].treatment_plans[my_item].treatment_procedures.length > 0) {
                  flag = 1;
                }
              }
            }
          }
          if (flag === 1) {
            return text;
          } else {
            return (
              <Input
                placeholder="Insurance"
                style={{ width: "100%" }}
                value={record.insuranceCoverage || ""}
                onChange={(e) => handleInputChange(e, record.key, "insuranceCoverage")}
              />
            );
          }
        } else {
          return text === null || text === undefined || text === "" ? "-" : "$" + text;
        }
      },
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      width: columnWidths.discount,
      render: function (text, record) {
        if (record.isNew) {
          if (itemize[record.key]) {
            return null;
          }
          return (
            <Input
              placeholder="Discount"
              style={{ width: "100%" }}
              value={record.discount || ""}
              onChange={(e) => handleInputChange(e, record.key, "discount")}
            />
          );
        } else if (edit[record.key]) {
          let flag = 0;
          for (let item in itemlist) {
            for (let my_item in itemlist[item].treatment_plans) {
              if (record.key + "" === itemlist[item].treatment_plans[my_item].id + "") {
                if (itemlist[item].treatment_plans[my_item].treatment_procedures.length > 0) {
                  flag = 1;
                }
              }
            }
          }
          if (flag === 1) {
            return text;
          } else {
            if (itemize[record.key]) {
              return null;
            }
            return (
              <Input
                placeholder="Discount"
                style={{ width: "100%" }}
                value={record.discount}
                onChange={(e) => handleInputChange(e, record.key, "discount")}
              />
            );
          }
        } else {
          if (text === null) text = "0";
          return text !== undefined && text !== null ? text + "%" : "-";
        }
      },
    },
    {
      title: "Patient Responsibility",
      dataIndex: "patientResponsibility",
      key: "patientResponsibility",
      width: columnWidths.patient_responsibility,
      render: function (text, record) {
        if (record.isNew && !itemize[record.key]) {
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Button type="primary" style={{ borderRadius: "100px" }} size="small" onClick={() => handleSaveTreatment(record)} disabled={isLoading}>
                Save
              </Button>

              <Button
                type="link"
                style={{ borderRadius: "100px" }}
                onClick={() => {
                  setItemize((prev) => ({ ...prev, [record.key]: false }));
                  setTableData((prevTableData) => prevTableData.filter((rowData) => rowData.key !== record.key));
                  setDisableAdd(false);
                  setNewKey(undefined);
                }}
              >
                Cancel
              </Button>
            </div>
          );
        }

        return text !== undefined ? `$${text}` : "-";
      },
    },
    {
      title: "Action",
      key: "action",
      width: columnWidths.action,
      render: function (_, record) {
        if (record.isNew) {
          return (
            <Checkbox checked={itemize[record.key]} onChange={(e) => setItemize((prev) => ({ ...prev, [record.key]: e.target.checked }))}>
              Itemize
            </Checkbox>
          );
        }

        return (
          <span>
            <Space size="middle">
              {record.isNew ? null : (
                <>
                  {edit[record.key] ? (
                    <Button
                      type="text"
                      icon={<img src={check} alt="Cancel" />}
                      style={{ color: "#979797" }}
                      onClick={function () {
                        cancelEdit(record);
                        handleReadData();
                      }}
                    />
                  ) : (
                    <Button
                      type="text"
                      icon={<img src={edit1} alt="Edit" />}
                      style={{ color: "#979797" }}
                      onClick={function () {
                        handleEdit(record);
                        handleReadData();
                      }}
                    />
                  )}
                  <Button
                    onClick={() => setModalState({ isVisible: true, deleteId: record })}
                    type="text"
                    icon={<img src={delete1} alt="Delete" />}
                    disabled={isDeletingTreatment || isGettingTreatmentPlans}
                    style={{ color: "#979797" }}
                  />
                  <Button
                    type="text"
                    icon={<img src={book} alt="Open" />}
                    style={{ color: "#979797" }}
                    onClick={function () {
                      handleOpen(record);
                      setSelectedTreatmentForEducationalContent(record);
                    }}
                  />
                </>
              )}
            </Space>
          </span>
        );
      },
    },
  ];

  const pmsColumns = [
    {
      title: "Procedure Code",
      dataIndex: "procedure_code",
      key: "procedure_code",
      width: 130,
      ellipsis: true,
      render: (text, record) => (
        <span style={{ maxWidth: "100px", display: "block" }}>{record.treatment_name ? record.treatment_name.split("-")[0] : "-"}</span>
      ), // Enforce width
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 100,
      ellipsis: true,
      render: (text, record) => (
        <span style={{ maxWidth: "100px", display: "block", textOverflow: "ellipsis" }}>
          {record.treatment_name ? record.treatment_name.split("-")[1] : "-"}
        </span>
      ), // Enforce width
    },
    {
      title: "Tooth / Quad",
      dataIndex: "tooth",
      key: "tooth",
      width: 100,
      ellipsis: true, // Enable ellipsis
      render: (text) => <span>{text ? text : "-"}</span>,
    },
    {
      title: "Estimated Cost",
      dataIndex: "estimated_cost",
      key: "estimated_cost",
      width: 100,
      ellipsis: true, // Enable ellipsis
      render: (value) => `$${value ? value : "-"}`, // Add $ before the value
    },
    {
      title: "Insurance Coverage",
      dataIndex: "insurance_estimate",
      key: "insurance_estimate",
      width: 100,
      ellipsis: true, // Enable ellipsis
      render: (value) => `$${value ? value : "-"}`, // Add $ before the value
    },
  ];

  const patientName = localStorage.getItem("patientName") ? localStorage.getItem("patientName") : localStorage.getItem("newPatientName");

  return (
    <>
      <ModalStep3
        isModalVisible={isModalVisible1}
        setIsModalVisible={setIsModalVisible1}
        selectedMember={item}
        handleSuccessAddToServer={handleSuccessAddToServer}
        patientId={selectedPatientId}
        handleReadData={handleReadData}
        processTreatmentPlans={() => processTreatmentPlans(props.data)}
      />

      {/* <div style={{ display: "flex", flexDirection: "row" }}>
        <Title level={4} style={{ marginBottom: 25 }}>
          {patientName ? patientName : props.data && props.data.first_name}'s Treatment Plan
        </Title>
        <Button
          style={{
            border: "1px solid #6B43B5",
            color: "#6B43B5",
            marginLeft: "auto",
            width: 124,
            height: 34,
            fontSize: 12
          }}
          onClick={onBack}
        >
          <img src={arrowBack} style={{width: 24, height: 24}}/>
          Back
        </Button>
      </div> */}

      <Card>
        <>
          <Title className="step-title" style={{ fontSize: 16, fontWeight: 500 }}>
            Doctor's Note
          </Title>

          <Input.TextArea
            ref={doctorsNoteInput}
            className="textarea-shadow-border2"
            value={note}
            onChange={handleTextAreaChange}
            placeholder={`Press Tab: Hi ${patientName ? patientName : props.data && props.data.first_name
              }, Your personalized treatment plan, which includes the cost estimate, payment options, treatment simulation, and educational content, is now ready for your review. If you have any questions or need further assistance, our friendly staff is here to help. Best regards, The ${officeName} Team`}
          />
        </>
        <>
          <Card>
            <div className="treatments-table-above-content">
              <Title className="step-title" style={{ fontSize: 16, fontWeight: 500 }}>
                Recommended Treatments
              </Title>

              <div className="rt-title-actions">
                {/* Source data (PMS) */}
                <Button
                  className="rt-btn rt-btn--ghost"
                  onClick={() => {
                    setIsModalVisible5(true);
                    setSelectModal(false);
                  }}
                >
                  <img src={eye} alt="eye icon" style={{ width: 16, height: 16, marginRight: 8 }} />
                  PMS Tx Data
                </Button>

                {/* Edit patient insurance policy */}
                <Tooltip title="Edit patient insurance">
                  <Button
                    className="rt-btn rt-btn--icon"
                    onClick={() => {
                      setShowPatientInsuranceFormModal(true);
                      setEditPatientInsuranceData(true);
                    }}
                  >
                    <img src={agnetEditIcon} alt="Edit patient insurance" style={{ width: 16, height: 16 }} />
                  </Button>
                </Tooltip>
              </div>
            </div>

            <div className="rt-actions">
              {/* Options (toggles) — across from the insurance actions */}
              <div className="rt-options">
                <Checkbox checked={optional} onChange={(e) => setOptional((prev) => !prev)}>
                  Third-Party Financing
                </Checkbox>
                {/* "Call patient with AI agent" checkbox removed: the patient
                    voice caller is retired (its OpenAI realtime model was
                    removed from the API); backend MakeCallView now 503s. */}
              </div>

              {/* Insurance group: breakdown/estimates. The standalone
                  "Insurance Eligibility" button was removed — for SunLife/CDCP a
                  full breakdown already captures eligibility, and the PC
                  predetermination path is deferred (see useGetPatientInsuranceEligibility
                  + PatientActionView, which remain for a future breakdown-fold). */}
              <div className="rt-actions__group">
                {/* Insurance (breakdowns + estimates) */}
                <Button
                  className="rt-btn"
                  onClick={() => {
                    setActiveInsuranceTab("breakdown");
                    setShowInsuranceModal(true);
                  }}
                  style={{ fontSize: 12 }}
                >
                  Insurance
                </Button>
              </div>
            </div>

            <div className="div-table1" ref={tableRef}>
              <Table
                dataSource={tableData}
                columns={columns3}
                scroll={{ x: "320px" }}
                pagination={false}
                tableLayout="fixed" // Ensures fixed widths are respected
                expandedRowKeys={expandedRowKeys}
                // rowSelection={rowSelection}
                onExpand={handleExpandTable}
                expandable={{
                  expandedRowRender: (record) => {
                    if (record.isNew) {
                      const EXTRA_COLUMNS_OFFSET2 = 1;
                      return (
                        <>
                          {/* This is a form for creating procedure for a new treatment */}
                          {itemize[record.key] &&
                            (record.isNew && newTreatmentProcedure ? (
                              <div style={{ marginTop: 20 }}>
                                <Row gutter={[10, 10]} align="middle">
                                  <Col span={EXTRA_COLUMNS_OFFSET2 * 3}></Col>
                                  <Col span={4} style={{ marginLeft: 26 }}>
                                    <Select
                                      placeholder="Procedure Code"
                                      style={{ width: "100%", height: 42, border: "1px solid #6B43B5", borderRadius: 7 }}
                                      onChange={(value) => handleExpandedInputChange(value, record.key, "procedure_code")}
                                      value={expandedRowInputValues[record.key] && expandedRowInputValues[record.key].procedure_code}
                                      // filterOption={(input, option) => option.props.children.toLowerCase().includes(input.toLowerCase())}
                                      filterOption={(input, option) => handleChangeProcedureSearch(input, option)}
                                      showSearch
                                    >
                                      {isFilteringProcedures ? (
                                        <Select.Option disabled key="loading">
                                          <Spin />
                                        </Select.Option>
                                      ) : procedures && procedures.length > 0 ? (
                                        procedures.map((item) =>
                                          item && item.id ? (
                                            <Select.Option key={item.id} value={item.id}>
                                              {`${item.procedure_code}-${item.procedure_code_description}`}
                                            </Select.Option>
                                          ) : null,
                                        )
                                      ) : (
                                        <Select.Option disabled key={-2} value="">
                                          Empty
                                        </Select.Option>
                                      )}
                                    </Select>
                                  </Col>

                                  <Col span={3}>
                                    <Input
                                      placeholder="Tooth/Quad"
                                      style={{ width: "100%" }}
                                      onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "tooth_quad")}
                                      value={expandedRowInputValues[record.key] && expandedRowInputValues[record.key].tooth_quad}
                                    />
                                  </Col>

                                  <Col span={3}>
                                    <Input
                                      placeholder="Cost"
                                      style={{ width: "100%" }}
                                      onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "estimated_cost")}
                                      value={expandedRowInputValues[record.key] && expandedRowInputValues[record.key].estimated_cost}
                                    />
                                  </Col>

                                  <Col span={3}>
                                    <Input
                                      placeholder="Insurance"
                                      style={{ width: "100%" }}
                                      onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "insurance_estimate")}
                                      value={expandedRowInputValues[record.key] && expandedRowInputValues[record.key].insurance_estimate}
                                    />
                                  </Col>

                                  <Col span={4} style={{ marginRight: 25 }}>
                                    <Input
                                      placeholder="Discount"
                                      style={{ width: "110px" }}
                                      onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "discount")}
                                      value={expandedRowInputValues[record.key] && expandedRowInputValues[record.key].discount}
                                    />
                                  </Col>

                                  <Col span={2} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <Button
                                      type="primary"
                                      style={{ width: "65%", fontSize: 10, marginBottom: 5 }}
                                      onClick={() => saveTreatmentPlanToServeraddProcedure(record, record.key)}
                                      loading={loading}
                                    >
                                      Add
                                    </Button>
                                    <p
                                      style={{ color: "#6B43B5", cursor: "pointer", textDecoration: "underline", fontSize: "10px", margin: 0 }}
                                      onClick={() => setNewTreatmentProcedure(false)}
                                    >
                                      Cancel
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              <div style={{ width: "50%", marginTop: 20, marginLeft: "auto", display: "flex", gap: 15 }}>
                                <Button style={{ width: "100%", height: 38 }} type="primary" onClick={handleAddNewTreatmentProcedure}>
                                  Add Procedure
                                </Button>
                                <Button
                                  style={{ width: "100%", height: 38, color: "#6B43B5", border: "1px solid #6B43B5" }}
                                  onClick={() => handleAddExistingPro(record.key, record)}
                                >
                                  Add From PMS
                                </Button>
                              </div>
                            ))}

                          <AddFromPMSModal
                            saveTreatmentPlanToServer={saveTreatmentPlanToServer}
                            expandedRowInputValues={expandedRowInputValues}
                            setSelectedRowKeys2={setSelectedRowKeys2}
                            selectedRowKeys2={selectedRowKeys2}
                            isModalVisible3={isModalVisible3}
                            handleCancel3={handleCancel3}
                            selectModal={selectModal}
                            pmsColumns={pmsColumns}
                            setSearch={setSearch}
                            record={record}
                            pms={pms}
                          />
                        </>
                      );
                    }

                    const treatmentPlan =
                      itemlist.length > 0 &&
                      itemlist[0].treatment_plans &&
                      Array.isArray(itemlist[0].treatment_plans) &&
                      itemlist[0].treatment_plans.length > 0 &&
                      itemlist[0].treatment_plans.find((plan) => Number(plan.id) === Number(record.key));

                    if (!treatmentPlan || !treatmentPlan.treatment_procedures) {
                      return (
                        <div>
                          {/* Show only add procedure buttons when no procedures exist */}
                          <div style={{ marginTop: 20, marginLeft: 150, display: "flex", gap: 15 }}>
                            <Button
                              style={{ width: "100%", height: 38 }}
                              type="primary"
                              onClick={setTreatmentProcedure((prevState) => [...prevState, record.key])}
                            >
                              Add Procedure
                            </Button>
                            <Button
                              style={{
                                width: "100%",
                                height: 38,
                                color: "#6B43B5",
                                border: "1px solid #6B43B5",
                              }}
                              onClick={() => handleAddExistingPro2(record.key, record)}
                            >
                              Add From PMS
                            </Button>
                          </div>
                        </div>
                      );
                    }

                    // INFO: Columns for showing a procedure or editing a procedure
                    // Define columns for the inner table
                    const innerColumns = [
                      // Empty columns for adjusting with the Selection and Expandation columns
                      {
                        title: "", // Empty title
                        dataIndex: "selection", // Unnecessary data name
                        key: "selection",
                        width: EXTRA_COLUMNS_WIDTH, // Same width as selection column
                        render: () => null, // No content
                      },

                      // Empty
                      {
                        title: "", // Empty title
                        dataIndex: "expand",
                        key: "expand",
                        width: EXTRA_COLUMNS_WIDTH, // Same width as selection column
                        render: () => null, // No content
                      },
                      // The main inner table columns

                      // Procedure Code Description
                      {
                        title: "Procedure Code Description",
                        dataIndex: ["procedure_code", "procedure_code_description"],
                        key: "procedure_code_description",
                        width: columnWidths.treatment,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            var selectedValue = "";
                            if (editedProcedures[index] && editedProcedures[index].procedure_code_description !== undefined) {
                              selectedValue = editedProcedures[index].procedure_code_description;
                            } else if (procedure && procedure.procedure_code && procedure.procedure_code.procedure_code_description !== undefined) {
                              selectedValue = procedure.procedure_code.procedure_code_description;
                            }

                            return (
                              <Select
                                placeholder="Procedure Code"
                                style={{ width: "100%", height: 42 }}
                                onChange={function (value) {
                                  handleProcedureInputChange(value, index, "procedure_code_description");
                                }}
                                value={selectedValue}
                                // filterOption={function (input, option) {
                                //   var optionText = String(option.props.children).toLowerCase();
                                //   return optionText.indexOf(input.toLowerCase()) !== -1;
                                // }}
                                filterOption={(input, option) => handleChangeProcedureSearch(input, option)}
                                showSearch
                              >
                                {procedures.map(function (item) {
                                  return (
                                    <Select.Option key={item.id} value={item.id}>
                                      {item.procedure_code} - {item.procedure_code_description}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            );
                          } else {
                            var procedureCode = "-";
                            var procedureDescription = "-";
                            if (procedure.procedure_code && procedure.procedure_code.procedure_code) {
                              procedureCode = procedure.procedure_code.procedure_code;
                            }
                            if (procedure.procedure_code && procedure.procedure_code.procedure_code_description) {
                              procedureDescription = procedure.procedure_code.procedure_code_description;
                            }
                            return (
                              <span>
                                {procedureCode} - {procedureDescription}
                              </span>
                            );
                          }
                        },
                      },

                      // Tooth/Quad
                      {
                        title: "Tooth/Quad",
                        dataIndex: "tooth",
                        key: "tooth",
                        width: columnWidths.tooth,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            var inputValue = "";
                            if (editedProcedures[index] && editedProcedures[index].tooth !== undefined) {
                              inputValue = editedProcedures[index].tooth;
                            } else if (procedure.tooth !== undefined) {
                              inputValue = procedure.tooth;
                            }
                            return (
                              <Input
                                value={inputValue}
                                onChange={function (e) {
                                  handleProcedureInputChange(e.target.value, index, "tooth");
                                }}
                                placeholder="Tooth/Quad"
                              />
                            );
                          } else {
                            return <span>{procedure.tooth || "-"}</span>;
                          }
                        },
                      },

                      // Estimate Const
                      {
                        title: "Estimated Cost",
                        dataIndex: "estimated_cost",
                        key: "estimated_cost",
                        width: columnWidths.estimated_cost,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            var costValue = 0;
                            if (editedProcedures[index] && editedProcedures[index].estimated_cost !== undefined) {
                              costValue = editedProcedures[index].estimated_cost;
                            } else if (procedure.estimated_cost !== undefined) {
                              costValue = procedure.estimated_cost;
                            }
                            return (
                              <Input
                                value={costValue}
                                onChange={function (e) {
                                  handleProcedureInputChange(e.target.value, index, "estimated_cost");
                                }}
                              />
                            );
                          } else if (procedure.estimated_cost === null || procedure.estimated_cost === undefined || procedure.estimated_cost === "") {
                            return "$0";
                          } else {
                            return <span>${procedure.estimated_cost}</span>;
                          }
                        },
                      },

                      // Insurance
                      {
                        title: "Insurance Estimate",
                        dataIndex: "insurance_estimate",
                        key: "insurance_estimate",
                        width: columnWidths.insurance_estimate,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            var insuranceValue = 0;
                            if (editedProcedures[index] && editedProcedures[index].insurance_estimate !== undefined) {
                              insuranceValue = editedProcedures[index].insurance_estimate;
                            } else if (procedure.insurance_estimate !== undefined) {
                              insuranceValue = procedure.insurance_estimate;
                            }
                            return (
                              <Input
                                value={insuranceValue}
                                onChange={function (e) {
                                  handleProcedureInputChange(e.target.value, index, "insurance_estimate");
                                }}
                              />
                            );
                          } else {
                            return (
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <span>
                                  {procedure.insurance_estimate === "0.00" || procedure.insurance_estimate === 0
                                    ? "$0.00"
                                    : procedure.insurance_estimate === null ||
                                      procedure.insurance_estimate === undefined ||
                                      procedure.insurance_estimate === ""
                                      ? "-"
                                      : `$${procedure.insurance_estimate}`}
                                </span>

                                <Tooltip
                                  title={
                                    procedure.eligible_today ? (
                                      <div>
                                        <p>{procedure.eligible_today}</p>
                                        <p>{procedure.eligible_amount}</p>
                                      </div>
                                    ) : (
                                      <div>No eligbility is available</div>
                                    )
                                  }
                                >
                                  <div
                                    style={{
                                      width: 16,
                                      height: 16,
                                      borderRadius: 100,
                                      border: "2px solid #d9d9d9",
                                      backgroundColor: procedure.eligible_today
                                        ? procedure.eligible_today.split(",")[0].toLowerCase() === "yes"
                                          ? "oklch(79.2% 0.209 151.711)"
                                          : procedure.eligible_today.split(",")[0].toLowerCase() === "no"
                                            ? "oklch(63.7% 0.237 25.331)"
                                            : "oklch(90.5% 0.182 98.111)"
                                        : "#d9d9d9",
                                    }}
                                  ></div>
                                </Tooltip>
                              </div>
                            );
                          }
                        },
                      },

                      // Dsicount
                      {
                        title: "Discount",
                        dataIndex: "discount",
                        key: "discount",
                        width: columnWidths.discount,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            var discountValue = 0;
                            if (
                              editedProcedures[index] &&
                              editedProcedures[index].discount !== undefined &&
                              editedProcedures[index].discount !== null
                            ) {
                              discountValue = editedProcedures[index].discount;
                            } else if (procedure && procedure.discount !== undefined && procedure.discount !== null) {
                              discountValue = procedure.discount;
                            }
                            return (
                              <Input
                                value={discountValue}
                                formatter={function (value) {
                                  return value || "";
                                }}
                                parser={function (value) {
                                  return value.replace("%", "");
                                }}
                                onChange={function (e) {
                                  handleProcedureInputChange(e.target.value, index, "discount");
                                }}
                              />
                            );
                          } else {
                            return <span>%{procedure.discount || "0"}</span>;
                          }
                        },
                      },

                      // Patient Responsibilty
                      {
                        title: "Patient Responsibility",
                        dataIndex: "patient_responsibility",
                        key: "patient_responsibility",
                        width: columnWidths.patient_responsibility,
                        render: function (text, procedure) {
                          return <span>${text || "-"}</span>;
                        },
                      },

                      // Action
                      {
                        title: "Actions",
                        key: "actions",
                        width: columnWidths.action,
                        render: function (text, procedure, index) {
                          var isEditing = editingProcedureIndex === procedure.id;
                          if (isEditing) {
                            return (
                              <Button
                                type="text"
                                onClick={() => saveEditedProcedure(index, procedure, procedure.id)}
                                icon={<img src={check} alt="Save" />}
                              />
                            );
                          } else {
                            return (
                              <Row style={{ flexWrap: "nowrap", marginRight: 50 }}>
                                <Button
                                  type="text"
                                  onClick={() => setEditingProcedureIndex(procedure.id)}
                                  icon={<img src={edit1} alt="Edit" />}
                                  style={{ marginRight: 20 }}
                                />
                                <Button
                                  type="text"
                                  disabled={isDeletingProcedure || isGettingTreatmentPlans}
                                  icon={<img src={delete1} alt="Delete" />}
                                  onClick={() => deleteProcedures(procedure.id)}
                                />
                              </Row>
                            );
                          }
                        },
                      },
                    ];

                    // Prepare data for the inner table
                    const data = treatmentPlan.treatment_procedures.map((procedure, index) => ({
                      key: procedure.id,
                      ...procedure,
                      index,
                    }));

                    const EXTRA_COLUMNS_OFFSET = 1; // Number of spans to offset (assuming each extra column spans 1 span)

                    return (
                      <div>
                        {
                          /*!treatmentProcedure.includes(record.key) &&*/ data.length > 0 && (
                            <Table
                              columns={innerColumns}
                              dataSource={data}
                              pagination={false}
                              rowKey="key"
                              expandedRowKeys={expandedRowKeys}
                              tableLayout="fixed" // Ensures fixed widths are respected
                              showHeader={false}
                              onExpand={handleExpandTable}
                            />
                          )
                        }

                        {/* Form for adding new procedures for a treatment that is already created */}
                        {treatmentProcedure.includes(record.key) ? (
                          <div style={{ marginTop: 20 }}>
                            <Row gutter={[10, 10]} align="middle">
                              {/* Offset to account for selection and expand columns */}
                              {/* Adjust multiplier based on actual span of extra columns */}
                              <Col span={EXTRA_COLUMNS_OFFSET * 3}></Col>
                              {/* Procedure Code Select */}
                              <Col span={4} style={{ marginLeft: 26 }}>
                                <Select
                                  placeholder="Procedure Code"
                                  style={{ width: "100%", height: 42, border: "1px solid #6B43B5", borderRadius: 7 }}
                                  onChange={(value) => handleExpandedInputChange(value, record.key, "procedure_code")}
                                  value={(expandedRowInputValues[record.key] && expandedRowInputValues[record.key].procedure_code) || undefined}
                                  // filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}
                                  filterOption={(input, option) => handleChangeProcedureSearch(input, option)}
                                  showSearch
                                >
                                  {procedures.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>
                                      {item.procedure_code} - {item.procedure_code_description}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Col>
                              {/* Tooth/Quad Input */}
                              <Col span={3}>
                                <Input
                                  placeholder="Tooth/Quad"
                                  style={{ width: "100%" }}
                                  onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "tooth_quad")}
                                  value={expandedRowInputValues[record.key] ? expandedRowInputValues[record.key].tooth_quad : ""}
                                />
                              </Col>
                              {/* Cost Input */}
                              <Col span={3}>
                                <Input
                                  placeholder="Cost"
                                  style={{ width: "100%" }}
                                  onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "estimated_cost")}
                                  value={expandedRowInputValues[record.key] ? expandedRowInputValues[record.key].estimated_cost : ""}
                                />
                              </Col>
                              {/* Insurance Input */}
                              <Col span={3}>
                                <Input
                                  placeholder="Insurance"
                                  style={{ width: "100%" }}
                                  onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "insurance_estimate")}
                                  value={
                                    expandedRowInputValues[record.key]
                                      ? expandedRowInputValues[record.key].insurance_estimate === "0.00"
                                        ? "-"
                                        : expandedRowInputValues[record.key].insurance_estimate
                                      : ""
                                  }
                                />
                              </Col>
                              {/* Discount Input */}
                              <Col span={4} style={{ marginRight: 25 }}>
                                <Input
                                  placeholder="Discount"
                                  style={{ width: "100px" }}
                                  onChange={(e) => handleExpandedInputChange(e.target.value, record.key, "discount")}
                                  value={expandedRowInputValues[record.key] ? expandedRowInputValues[record.key].discount : ""}
                                />
                              </Col>
                              {/* Add and Cancel Buttons */}
                              <Col span={2} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                <Button
                                  type="primary"
                                  style={{
                                    width: "65%",
                                    fontSize: 10,
                                    marginBottom: 5,
                                  }}
                                  disabled={isLoading}
                                  onClick={() => postProcedure(record, record.key)}
                                  loading={loading}
                                >
                                  Add
                                </Button>
                                <p
                                  style={{
                                    color: "#6B43B5",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                    margin: 0,
                                  }}
                                  onClick={() => {
                                    const filterItems = treatmentProcedure.filter((procedure) => procedure !== record.key);
                                    setTreatmentProcedure(filterItems);
                                  }}
                                >
                                  Cancel
                                </p>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "50%",
                              marginTop: 20,
                              marginLeft: "auto",
                              display: "flex",
                              gap: 15,
                            }}
                          >
                            {/* Add Procedure Button */}
                            <Button
                              style={{ width: "100%", height: 38 }}
                              type="primary"
                              onClick={() => setTreatmentProcedure((prevState) => [...prevState, record.key])}
                            >
                              Add Procedure
                            </Button>

                            {/* PMS Button */}
                            <Button
                              style={{ width: "100%", height: 38, color: "#6B43B5", border: "1px solid #6B43B5" }}
                              onClick={() => handleAddExistingPro2(record.key, record)}
                            >
                              Add From PMS
                            </Button>

                            {/* Import From Predetermination Button */}
                            <Button
                              style={{ width: "100%", height: 38, color: "#6B43B5", border: "1px solid #6B43B5" }}
                              onClick={() => {
                                setShowPredeterminationModal(true);
                                setPredeterminationTreatmentID(record.key);
                              }}
                            >
                              Import From Predetermination
                            </Button>
                          </div>
                        )}
                      </div>
                    );
                  },
                  // Check if the record (row) is new or not, if it is, then make it expandable if the itemize is marked otherwise don't
                  rowExpandable: (record) => (record.isNew ? itemize[record.key] : true),
                }}
              />
            </div>
            <Button
              className={disableadd || isGettingTreatmentPlans ? "step1-button-disabled" : "step1-button"}
              type="default"
              style={disableadd || isGettingTreatmentPlans ? { color: "gray" } : {}}
              onClick={addTreatmentPlan}
              disabled={disableadd || isGettingTreatmentPlans}
            >
              Add Treatment
              <img src={disableadd || isGettingTreatmentPlans ? add : addCircle} style={{ width: 16, height: 16 }} alt="add-treatment" />
              {/* Hover icon (white one) */}
              <img src={add} className="add-icon hover-icon" style={{ width: 16, height: 16, marginLeft: "-20px" }} alt="add-treatment" />
            </Button>
          </Card>
          <label className="inputLabel" style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>
            Files
          </label>
          <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {imageFile.map((file, index) => {
              let urlObject;
              let pathname = "";
              let fileType = "";

              try {
                urlObject = new URL(file.path);
                pathname = urlObject.pathname;
                fileType = pathname.split(".").pop();
              } catch (e) {
                pathname = file.name || "";
                fileType = pathname.split(".").pop();
              }

              const fileType2 = file.file_type;

              // Get the appropriate icon based on file type
              const fileIcon = getFileIcon(fileType);

              return (
                <div
                  key={file.name}
                  className="uploaded-file-preview"
                  style={{
                    display: "inline-block",
                    marginRight: 10,
                    position: "relative",
                  }}
                >
                  {file.type && file.type.startsWith("image") ? (
                    <>
                      <a href={getImageUrl(file)} download style={{ bottom: 5 }}>
                        <img
                          src={getImageUrl(file)}
                          alt={folder}
                          style={{
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid #6B43B5",
                            width: 199,
                            height: 132,
                            position: "relative",
                          }}
                        />

                        {/* Download Icon */}
                        <div
                          className="downloadIconContainer"
                          style={{
                            position: "absolute",
                            top: "30%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: "5",
                            width: 30,
                            height: 30,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img width={15} height={15} src={downloadIcon} alt="download" />
                        </div>

                        <div
                          style={{
                            fontSize: 12,
                            color: "#6B43B5",
                            marginTop: 10,
                            textAlign: "center",
                            marginBottom: 45,
                            width: 200,
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {file.name}
                        </div>
                      </a>
                    </>
                  ) : (
                    <div
                      style={{
                        width: 200,
                        height: 133,
                        marginBottom: 65,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = file.path ? file.path : getImageUrl(file);
                        link.download = "";
                        link.click();
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #6B43B5",
                          borderRadius: 8,
                          width: 200,
                          height: 133,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <a href={file.path ? file.path : getImageUrl(file)} download style={{ bottom: -20 }}>
                          <div style={{ fontSize: 50, color: "#6B43B5" }}>
                            {fileType === "pdf" ||
                              fileType === "msword" ||
                              fileType === "vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                              fileType === "xlsx" ||
                              fileType === "pptx" ||
                              fileType === "zip" ||
                              fileType === "rar" ||
                              fileType === "docx" ||
                              fileType === "aspx" ||
                              fileType === "mp4" ||
                              fileType === "mkv" ? (
                              <>
                                <img src={fileIcon} alt={`${fileType2} icon`} width={70} height={70} />
                                <div
                                  className="downloadIconContainer"
                                  style={{
                                    position: "absolute",
                                    top: "35%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: "5",
                                    width: 30,
                                    height: 30,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <img width={15} height={15} src={downloadIcon} alt="download" />
                                </div>
                              </>
                            ) : (
                              <>
                                <img
                                  src={file.path}
                                  alt={folder}
                                  style={{
                                    objectFit: "cover",
                                    width: 198,
                                    height: 131,
                                    borderRadius: 8,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                />
                                <div
                                  className="downloadIconContainer"
                                  style={{
                                    position: "absolute",
                                    top: "35%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: "5",
                                    width: 30,
                                    height: 30,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <a href={file.path} download style={{ position: "absolute", bottom: -20 }}>
                                    <img width={15} height={15} src={downloadIcon} alt="download" />
                                  </a>
                                </div>
                              </>
                            )}
                          </div>
                        </a>
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6B43B5",
                          marginTop: 10,
                          textAlign: "center",
                          marginBottom: 45,
                          width: 200,
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {file.name}
                      </div>
                    </div>
                  )}
                  <button
                    onClick={() => handleDelete2(file.id, index)}
                    style={{
                      position: "absolute",
                      top: 5,
                      right: 5,
                      background: "transparent",
                      color: "#B7B7B7",
                      border: "none",
                      borderRadius: "50%",
                      width: 23,
                      height: 20,
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    x
                  </button>
                </div>
              );
            })}
            <div
              style={{
                width: 200,
                padding: 0,
                border: "1px dashed #B7B7B7",
                borderWidth: 3,
                borderRadius: 8,
                display: "inline-block",
                verticalAlign: "top",
                marginLeft: 15,
                height: 133,
              }}
            >
              <div className="clearfix" style={{ width: "100%" }}>
                <Upload
                  key={uploadKey}
                  onChange={handleUploadChange}
                  onRemove={handleRemove}
                  fileList={imageFile} // Controlled fileList
                  showUploadList={false} // Hide the uploaded files list
                >
                  <label
                    className="formLabel"
                    style={{
                      color: "gray",
                      backgroundColor: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      cursor: "pointer",
                      maxWidth: "150px",
                      minWidth: "unset",
                      paddingTop: 15,
                      paddingBottom: 15,
                      flexDirection: "column",
                      fontSize: 14,
                    }}
                  >
                    <div style={{ top: -15, position: "relative", marginLeft: 45 }}>
                      <img src={add} alt="" />
                    </div>
                    <div
                      style={{
                        color: "#B7B7B7",
                        fontSize: 12,
                        marginBottom: 5,
                        marginLeft: 50,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      Drag and drop or <span style={{ color: "#6B43B5" }}>Browse</span> your files
                    </div>
                  </label>
                </Upload>
              </div>
            </div>

            <style jsx>{`
              @media (max-width: 768px) {
                .clearfix {
                  width: 100% !important;
                }

                .formLabel {
                  max-width: 120px !important;
                  margin-left: 0 !important;
                  padding: 10px !important;
                }

                Col {
                  margin-left: 0 !important;
                  height: auto !important;
                  padding: 10px !important;
                }
              }
            `}</style>
          </div>
        </>
      </Card>
      <div className="step2-div" style={{ marginBottom: 100, width: "100%" }}>
        <Row style={{ display: "flex", gap: 20 }}>
          <Button
            className="render-btn2"
            style={{ marginRight: 10, border: "1px solid #6B43B5", color: "#6B43B5" }}
            onClick={() => setShowShareModal(true)}
          >
            Share
          </Button>
          <Button className="render-btn2" style={{ marginRight: 10, border: "1px solid #6B43B5", color: "#6B43B5" }} onClick={handlePreviewClick}>
            Preview
          </Button>
        </Row>
        <Row style={{ marginLeft: "auto" }}>
          <Button
            className="render-btn2"
            onClick={() => handleApprove2("draft")}
            loading={isLoading1}
            style={{ marginRight: 10, border: "1px solid #6B43B5", color: "#6B43B5" }}
            disabled={!selectedTreatmentIds || selectedTreatmentIds.length === 0}
          >
            Save
          </Button>
          <Button
            className="render-btn2"
            type="primary"
            onClick={() => {
              handleApprove2("sent");
            }}
            loading={isLoading}
            disabled={!selectedTreatmentIds || selectedTreatmentIds.length === 0}
          >
            Send
          </Button>
        </Row>
      </div>

      {/* Educational Content Modal */}
      <Modal title="Educational Content" open={isModalVisible} style={{ minWidth: 300, minHeight: 800 }} footer={null} onCancel={handleCancel}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Spin size="large" /> {/* Ant Design spinner */}
          </div>
        ) : edulist && edulist.educational_content && edulist.educational_content.length > 0 ? (
          <div>
            <div style={{ marginBottom: 15, display: "flex", flexDirection: "row" }}>
              {modaledit2 ? (
                <Button
                  type="text"
                  icon={<img src={tick} alt="Open" />}
                  style={{ color: "#979797", marginLeft: "auto" }}
                  onClick={() => updateEducational3()}
                />
              ) : (
                <Button
                  type="text"
                  icon={<img src={edit2} alt="Open" />}
                  style={{ color: "#979797", marginLeft: "auto" }}
                  onClick={() => {
                    let currentContent = null;
                    let contentId = null;

                    // Check if edulist and educational_content exist and are valid
                    if (
                      edulist &&
                      edulist.educational_content &&
                      Array.isArray(edulist.educational_content) &&
                      edulist.educational_content.length > 0
                    ) {
                      currentContent = edulist.educational_content[0]; // Access the first element directly
                      contentId = currentContent.id; // Extract the id
                    } else {
                      console.error("educational_content is missing or empty.");
                    }

                    handleEditModal2(contentId);
                  }}
                />
              )}
            </div>
            <Card>
              {modaledit2 ? (
                <Select
                  mode="multiple"
                  maxTagCount={1}
                  popupRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          type="primary"
                          style={{
                            background: "white",
                            color: "#6B43B5",
                            width: "100%",
                            border: "1px solid #6B43B5",
                            borderRadius: "0 0 8px 8px",
                            height: 52,
                          }}
                          onClick={() => handleOpen2()}
                        >
                          Add Yours
                        </Button>
                      </div>
                    </>
                  )}
                  value={eduvalue} // Bind the value to the preselected and selected items
                  onDropdownVisibleChange={(open) => {
                    if (open) {
                      // Collect all video_file IDs from educational_content
                      const targetIds = edulist.educational_content.flatMap((content) => content.video_file.map((video) => video.id));

                      // Filter `targetIds` to only those matching IDs in `edu`
                      const matchingIds = edu.filter((item) => targetIds.includes(item.id)).map((item) => item.id);

                      // Combine matching IDs with current selections
                      const updatedSelectedItems = [...new Set([...eduvalue, ...matchingIds])];

                      // Update the state with preselected items
                      setEduValue(updatedSelectedItems);
                    }
                  }}
                  onChange={(selectedItems) => {
                    // Update the selected items when the user changes selection
                    setEduValue(selectedItems);
                  }}
                  style={{ width: "100%", height: 42, borderRadius: 7, border: "1px solid #6B43B5" }}
                  placeholder="Search Content"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    // Customize search to match 'name' or 'description'
                    const children = (option && option.children) || "";
                    const searchText = input ? input.toString().toLowerCase() : "";

                    const result = children.toString().toLowerCase().includes(searchText);
                    return result;
                  }}
                >
                  {edu && edu.length > 0 ? (
                    edu.map((item) =>
                      item.id ? (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name || item.description || `ID: ${item.id}`}
                        </Select.Option>
                      ) : null,
                    )
                  ) : (
                    <Select.Option disabled key={-2} value="">
                      empty
                    </Select.Option>
                  )}
                </Select>
              ) : hasVideo ? (
                isYouTube || isSpearEdu || isPatientApi ? (
                  <iframe
                    width="100%"
                    height="246px"
                    src={videoLink.replace("watch?v=", "embed/")}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Educational Video"
                  ></iframe>
                ) : (
                  <video width="100%" height="246px" controls>
                    <source src={videoLink || currentVideo.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )
              ) : (
                <p>No video available</p>
              )}
            </Card>
            <Row justify="center" style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<img src={arrowLeft} alt="Open" />}
                style={{ marginTop: 25 }}
                disabled={currentPage === 0}
                onClick={handlePrevious}
              />
              <span style={{ margin: "0 10px", lineHeight: "1.5", marginTop: 25 }}> {currentPage + 1} </span>
              <Button
                type="text"
                icon={<img src={arrowRight} alt="Open" />}
                style={{ marginTop: 25 }}
                disabled={currentPage === totalPages - 1}
                onClick={handleNext}
              />
            </Row>
          </div>
        ) : (
          <>
            <div>
              <div>
                <Select
                  mode="multiple"
                  value={eduvalue}
                  maxTagCount={1}
                  popupRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          type="primary"
                          style={{
                            background: "white",
                            color: "#6B43B5",
                            width: "100%",
                            border: "1px solid #6B43B5",
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            borderBottomLeftRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 52,
                          }}
                          onClick={() => handleOpen2()}
                        >
                          Add Yours
                        </Button>
                      </div>
                    </>
                  )}
                  onChange={(selectedItems) => {
                    setEduValue(selectedItems); // Limit selection to 1
                  }}
                  style={{ width: "100%", height: 42, borderRadius: 7, border: "1px solid #6B43B5" }}
                  placeholder="Search Content"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    // Customize search to match 'name' or 'description'
                    const children = (option && option.children) || "";
                    const searchText = input ? input.toString().toLowerCase() : "";

                    const result = children.toString().toLowerCase().includes(searchText);
                    return result;
                  }}
                >
                  {edu && edu.length > 0 ? (
                    edu.map((item) =>
                      item && item.id ? (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ) : null,
                    )
                  ) : (
                    <Select.Option disabled key={-2} value="">
                      empty
                    </Select.Option>
                  )}
                </Select>
              </div>
            </div>
            <Row justify="end" style={{ marginTop: 35 }}>
              <Button type="primary" onClick={() => updateEducational()}>
                Done
              </Button>
            </Row>
          </>
        )}
      </Modal>

      {/* New Educational Content Modal */}
      <NewEducationalContentModal
        selectedTreatmentForEducationalContent={selectedTreatmentForEducationalContent}
        handleCheckboxChange={handleCheckboxChange}
        handleUploadChange2={handleUploadChange2}
        postEducational={postEducational}
        isModalVisible2={isModalVisible2}
        handleCancel2={handleCancel2}
        isChecked={isChecked}
        videoFile={videoFile}
        setText={setText}
        setName={setName}
        setUrl={setUrl}
        form={form}
        url={url}
        add={add}
      />

      {/* PMS Modal */}
      <PMSDataModal
        setExpandedRowInputValues={setExpandedRowInputValues}
        setNewTreatmentProcedure={setNewTreatmentProcedure}
        expandedRowInputValues={expandedRowInputValues}
        setTreatmentProcedure={setTreatmentProcedure}
        processTreatmentPlans={processTreatmentPlans}
        totalPmsTablePageSize={totalPmsTablePageSize}
        setSelectedRowKeys2={setSelectedRowKeys2}
        setIsModalVisible3={setIsModalVisible3}
        treatmentProcedure={treatmentProcedure}
        setIsModalVisible5={setIsModalVisible5}
        patientID={props.data && props.data.id}
        handleReadPmsData={handleReadPmsData}
        selectedRowKeys2={selectedRowKeys2}
        isGettingPmsData={isGettingPmsData}
        isModalVisible5={isModalVisible5}
        postExistingPro={postExistingPro}
        handleReadData2={handleReadData2}
        setPmsTablePage={setPmsTablePage}
        setPmsDataType={setPmsDataType}
        setDisableAdd={setDisableAdd}
        handleCancel4={handleCancel4}
        setTableData={setTableData}
        pmsTablePage={pmsTablePage}
        pmsDataType={pmsDataType}
        selectModal={selectModal}
        setLoading={setLoading}
        pmsColumns={pmsColumns}
        setSearch={setSearch}
        setNewKey={setNewKey}
        optional={optional}
        itemlist={itemlist}
        loading={loading}
        search={search}
        pms={pms}
      />

      {/* Confirm Detele Modal */}
      <ConfirmDeleteModal setModalState={setModalState} modalState={modalState} handleDelete={handleDelete} />

      {/* Share Modal */}
      <ShareModal
        disabled={isLoading1 || isLoading || isGettingTreatmentPlans}
        setShowShareModal={setShowShareModal}
        showSentDraftLink={showSentDraftLink}
        sentDraftLinkRef={sentDraftLinkRef}
        showShareModal={showShareModal}
        handleApprove2={handleApprove2}
        sentDraftLink={sentDraftLink}
        hasSent={hasSent}
      />

      {/* Predetermination Modal */}
      <PredeterminationModal
        setPredeterminationTreatmentID={setPredeterminationTreatmentID}
        setShowPredeterminationModal={setShowPredeterminationModal}
        predeterminationTreatmentID={predeterminationTreatmentID}
        showPredeterminationModal={showPredeterminationModal}
        predeterminationBatchID={predeterminationBatchID}
        eligibilityData={predeterminationData}
        agentType={agentType}
        patient={props.data}
      />

      {/* Combined Insurance Modal (Breakdowns + Estimates tabs) */}
      <InsuranceMasterModal
        open={showInsuranceModal}
        setOpen={setShowInsuranceModal}
        activeTab={activeInsuranceTab}
        setActiveTab={setActiveInsuranceTab}
        patientPolicies={patientPolicies}
        patient={patientWithNote}
        agentType={agentType}
        handleScraperAgentCall={handleScraperAgentCall}
        isAgentScrappingData={isAgentScrappingData}
        onPoliciesChanged={handleReadData2}
        onNoteSaved={handleModalNoteSaved}
        onRequestAddPolicy={() => {
          setPolicyModalInitialMode("add");
          setEditPatientInsuranceData(false);
          setShowPatientInsuranceFormModal(true);
        }}
        breakdownData={breakdownData}
        setLastUploadedBreakdown={setLastUploadedBreakdown}
        isGettingDoctorNote={isGettingDoctorNote}
        checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
        breakdownEligibilityRefreshTick={breakdownEligibilityRefreshTick}
        breakdownModalEligibilityActive={breakdownModalEligibilityActive}
        setAgentCancelProcess={setCancelProcess}
        eligibilityAgent2FAStatus={agent2FAStatus}
        eligibilityTaskStatus={eligibilityTaskStatus}
        predeterminationData={predeterminationData}
      />

      {/* Eligibility Form Modal */}
      <PatientPolicyInfoFormModal
        setShowPatientInsuranceFormModal={(open) => {
          setShowPatientInsuranceFormModal(open);
          if (!open) setPolicyModalInitialMode(undefined);
        }}
        checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
        showPatientInsuranceFormModal={showPatientInsuranceFormModal}
        setEditPatientInsuranceData={setEditPatientInsuranceData}
        editPatientInsuranceData={editPatientInsuranceData}
        patientID={props.data && props.data.id}
        patient={props.data}
        setCancelProcess={setCancelProcess}
        handleReadData2={handleReadData2}
        initialMode={policyModalInitialMode}
      />

      {/* 2FA Form Modal */}
      <Eligibility2FAFormModal
        setShowEligibility2FAFormModal={setShowEligibility2FAFormModal}
        showEligibility2FAFormModal={showEligibility2FAFormModal}
        eligibilityAgentToken={eligibilityAgentToken}
        setCancelProcess={setCancelProcess}
        type="eligibility"
      />

      {/* Show Eligiblity Data Modal */}
      <EligibilityDataModal
        setShowEligibilityDataModal={setShowEligibilityDataModal}
        showEligibilityDataModal={showEligibilityDataModal}
        eligibilityData={eligibilityData}
        patientPolicies={patientPolicies}
        selectedPolicy={selectedPolicy}
      />


      <SelectPolicyItemModal
        checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
        setShowPatientInsuranceFormModal={setShowPatientInsuranceFormModal}
        setShowSelectPolicyItemModal={setShowSelectPolicyItemModal}
        showSelectPolicyItemModal={showSelectPolicyItemModal}
        setSelectedPolicy={setSelectedPolicy}
        patientPolicies={patientPolicies}
        selectedPolicy={selectedPolicy}
        setAgentType={setAgentType}
        agentType={agentType}
        patientID={props.data && props.data.id}
        onPoliciesChanged={handleReadData2}
      />
    </>
  );
};

export default TreatmentCardStep2;
